// src/bpm.ts
var APPROVER = {
  code: "approver",
  label: "\u041A\u0442\u043E \u0443\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u0435\u0442",
  description: "\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0439 \u0441\u043E\u0433\u043B\u0430\u0441\u0443\u044E\u0449\u0438\u0439 \u2014 \u0434\u0438\u0440\u0435\u043A\u0442\u043E\u0440 \u0438\u043B\u0438 \u0437\u0430\u043C\u0435\u0441\u0442\u0438\u0442\u0435\u043B\u044C. \u0426\u0438\u043A\u043B \u043F\u043E \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044F\u043C \u0438\u0434\u0451\u0442 \u0434\u043E \u043D\u0435\u0433\u043E."
};
var ROUTES = {
  vacation: {
    code: "vacation",
    title: "\u0417\u0430\u044F\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u0430 \u043E\u0442\u043F\u0443\u0441\u043A",
    entityType: "vacation",
    roles: [
      APPROVER,
      {
        code: "clerk",
        label: "\u041A\u0442\u043E \u043E\u0444\u043E\u0440\u043C\u043B\u044F\u0435\u0442",
        description: "\u041A\u0430\u0434\u0440\u043E\u0432\u0438\u043A: \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u0442 \u0441\u043E\u0433\u043B\u0430\u0441\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u0437\u0430\u044F\u0432\u043B\u0435\u043D\u0438\u044F \u0438 \u043E\u0444\u043E\u0440\u043C\u043B\u044F\u0435\u0442 \u043E\u0442\u043F\u0443\u0441\u043A."
      }
    ],
    steps: [
      { id: "approve", type: "approval_chain", title: "\u0421\u043E\u0433\u043B\u0430\u0441\u043E\u0432\u0430\u043D\u0438\u0435", until: "approver" },
      { id: "approved", type: "status", status: "approved", title: "\u041E\u0442\u043F\u0443\u0441\u043A \u0441\u043E\u0433\u043B\u0430\u0441\u043E\u0432\u0430\u043D" },
      {
        id: "notify_clerk",
        type: "notify",
        title: "\u0423\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435 \u043A\u0430\u0434\u0440\u043E\u0432\u0438\u043A\u0443",
        to: [{ role: "clerk" }],
        message: "\u0421\u043E\u0433\u043B\u0430\u0441\u043E\u0432\u0430\u043D \u043E\u0442\u043F\u0443\u0441\u043A \u2014 \u0435\u0433\u043E \u043D\u0443\u0436\u043D\u043E \u0431\u0443\u0434\u0435\u0442 \u043E\u0444\u043E\u0440\u043C\u0438\u0442\u044C"
      },
      {
        id: "wait",
        type: "wait",
        title: "\u041E\u0436\u0438\u0434\u0430\u043D\u0438\u0435: \u0437\u0430 5 \u0434\u043D\u0435\u0439 \u0434\u043E \u043D\u0430\u0447\u0430\u043B\u0430",
        dateField: "startDate",
        offsetDays: -5,
        notify: [{ author: true }],
        message: "\u0427\u0435\u0440\u0435\u0437 5 \u0434\u043D\u0435\u0439 \u043D\u0430\u0447\u0438\u043D\u0430\u0435\u0442\u0441\u044F \u0432\u0430\u0448 \u043E\u0442\u043F\u0443\u0441\u043A"
      },
      {
        id: "register",
        type: "task",
        title: "\u041E\u0444\u043E\u0440\u043C\u0438\u0442\u044C \u043E\u0442\u043F\u0443\u0441\u043A",
        assignee: { role: "clerk" },
        hint: "\u041E\u0444\u043E\u0440\u043C\u0438\u0442\u0435 \u043E\u0442\u043F\u0443\u0441\u043A \u0432 1\u0421:\u0417\u0423\u041F \u0438 \u043E\u0442\u043C\u0435\u0442\u044C\u0442\u0435 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435.",
        doneLabel: "\u041E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u043E"
      },
      { id: "done", type: "status", status: "registered", title: "\u041E\u0442\u043F\u0443\u0441\u043A \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D" }
    ]
  },
  business_trip: {
    code: "business_trip",
    title: "\u0417\u0430\u044F\u0432\u043B\u0435\u043D\u0438\u0435 \u043D\u0430 \u043A\u043E\u043C\u0430\u043D\u0434\u0438\u0440\u043E\u0432\u043A\u0443",
    entityType: "request",
    roles: [
      APPROVER,
      {
        code: "bookkeeper",
        label: "\u041A\u0442\u043E \u043E\u0444\u043E\u0440\u043C\u043B\u044F\u0435\u0442",
        description: "\u0411\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440: \u043E\u0444\u043E\u0440\u043C\u043B\u044F\u0435\u0442 \u043A\u043E\u043C\u0430\u043D\u0434\u0438\u0440\u043E\u0432\u043A\u0443 \u0438 \u043F\u0440\u043E\u0432\u0435\u0440\u044F\u0435\u0442 \u043E\u0442\u0447\u0451\u0442\u043D\u044B\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B."
      }
    ],
    steps: [
      { id: "approve", type: "approval_chain", title: "\u0421\u043E\u0433\u043B\u0430\u0441\u043E\u0432\u0430\u043D\u0438\u0435", until: "approver" },
      { id: "approved", type: "status", status: "approved", title: "\u041A\u043E\u043C\u0430\u043D\u0434\u0438\u0440\u043E\u0432\u043A\u0430 \u0441\u043E\u0433\u043B\u0430\u0441\u043E\u0432\u0430\u043D\u0430" },
      {
        id: "arrange",
        type: "task",
        title: "\u041E\u0444\u043E\u0440\u043C\u0438\u0442\u044C \u043A\u043E\u043C\u0430\u043D\u0434\u0438\u0440\u043E\u0432\u043A\u0443",
        assignee: { role: "bookkeeper" },
        hint: "\u041E\u0444\u043E\u0440\u043C\u0438\u0442\u0435 \u043F\u0440\u0438\u043A\u0430\u0437 \u0438 \u0432\u044B\u0434\u0430\u0439\u0442\u0435 \u0430\u0432\u0430\u043D\u0441, \u0435\u0441\u043B\u0438 \u043D\u0443\u0436\u0435\u043D.",
        doneLabel: "\u041E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u043E"
      },
      {
        id: "report",
        type: "task",
        title: "\u041F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043E\u0442\u0447\u0451\u0442\u043D\u044B\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B",
        assignee: { author: true },
        hint: "\u041F\u043E\u0441\u043B\u0435 \u043F\u043E\u0435\u0437\u0434\u043A\u0438 \u043F\u0440\u0438\u043B\u043E\u0436\u0438\u0442\u0435 \u0431\u0438\u043B\u0435\u0442\u044B, \u0447\u0435\u043A\u0438 \u0438 \u043E\u0442\u0447\u0451\u0442 \u043E \u043A\u043E\u043C\u0430\u043D\u0434\u0438\u0440\u043E\u0432\u043A\u0435.",
        doneLabel: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B",
        fields: [
          { key: "reportFiles", label: "\u041E\u0442\u0447\u0451\u0442\u043D\u044B\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B", type: "files", required: true },
          { key: "reportText", label: "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439", type: "textarea" }
        ]
      },
      {
        id: "check",
        type: "task",
        title: "\u041F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432",
        assignee: { role: "bookkeeper" },
        doneLabel: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u043F\u0440\u0438\u043D\u044F\u0442\u044B",
        returnTo: { step: "report", label: "\u0417\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u044C \u0435\u0449\u0451 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B" }
      },
      { id: "closed", type: "status", status: "closed", title: "\u041A\u043E\u043C\u0430\u043D\u0434\u0438\u0440\u043E\u0432\u043A\u0430 \u0437\u0430\u043A\u0440\u044B\u0442\u0430" }
    ]
  },
  invoice: {
    code: "invoice",
    title: "\u0421\u0447\u0451\u0442 \u043D\u0430 \u043E\u043F\u043B\u0430\u0442\u0443",
    entityType: "request",
    roles: [
      APPROVER,
      {
        code: "bookkeeper",
        label: "\u041A\u0442\u043E \u043E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0435\u0442",
        description: "\u0411\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440: \u043E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0435\u0442 \u0441\u0447\u0451\u0442 \u0438 \u0441\u043E\u0431\u0438\u0440\u0430\u0435\u0442 \u0437\u0430\u043A\u0440\u044B\u0432\u0430\u044E\u0449\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B."
      }
    ],
    steps: [
      { id: "approve", type: "approval_chain", title: "\u0421\u043E\u0433\u043B\u0430\u0441\u043E\u0432\u0430\u043D\u0438\u0435", until: "approver" },
      { id: "approved", type: "status", status: "approved", title: "\u041E\u043F\u043B\u0430\u0442\u0430 \u0441\u043E\u0433\u043B\u0430\u0441\u043E\u0432\u0430\u043D\u0430" },
      {
        id: "pay",
        type: "task",
        title: "\u041E\u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0441\u0447\u0451\u0442",
        assignee: { role: "bookkeeper" },
        doneLabel: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D\u043E",
        fields: [
          { key: "paymentNumber", label: "\u041D\u043E\u043C\u0435\u0440 \u043F\u043B\u0430\u0442\u0451\u0436\u043D\u043E\u0433\u043E \u043F\u043E\u0440\u0443\u0447\u0435\u043D\u0438\u044F", type: "text", required: true },
          { key: "paymentDate", label: "\u0414\u0430\u0442\u0430 \u043E\u043F\u043B\u0430\u0442\u044B", type: "date", required: true }
        ]
      },
      { id: "paid", type: "status", status: "paid", title: "\u0421\u0447\u0451\u0442 \u043E\u043F\u043B\u0430\u0447\u0435\u043D" },
      {
        id: "docs",
        type: "task",
        title: "\u0421\u043E\u0431\u0440\u0430\u0442\u044C \u0437\u0430\u043A\u0440\u044B\u0432\u0430\u044E\u0449\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B",
        assignee: { author: true },
        hint: "\u041F\u0440\u0438\u043B\u043E\u0436\u0438\u0442\u0435 \u0430\u043A\u0442, \u043D\u0430\u043A\u043B\u0430\u0434\u043D\u0443\u044E \u0438\u043B\u0438 \u0423\u041F\u0414 \u043E\u0442 \u043F\u043E\u0441\u0442\u0430\u0432\u0449\u0438\u043A\u0430.",
        doneLabel: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B",
        fields: [{ key: "closingFiles", label: "\u0417\u0430\u043A\u0440\u044B\u0432\u0430\u044E\u0449\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B", type: "files", required: true }]
      },
      {
        id: "check",
        type: "task",
        title: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u044B",
        assignee: { role: "bookkeeper" },
        doneLabel: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u043F\u0440\u0438\u043D\u044F\u0442\u044B",
        returnTo: { step: "docs", label: "\u0417\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u044C \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E" }
      },
      { id: "closed", type: "status", status: "closed", title: "\u0421\u0447\u0451\u0442 \u0437\u0430\u043A\u0440\u044B\u0442" }
    ]
  },
  cash: {
    code: "cash",
    title: "\u0412\u044B\u0434\u0430\u0447\u0430 \u043D\u0430\u043B\u0438\u0447\u043D\u044B\u0445",
    entityType: "request",
    roles: [
      APPROVER,
      {
        code: "bookkeeper",
        label: "\u041A\u0442\u043E \u0432\u044B\u0434\u0430\u0451\u0442",
        description: "\u0411\u0443\u0445\u0433\u0430\u043B\u0442\u0435\u0440 \u0438\u043B\u0438 \u043A\u0430\u0441\u0441\u0438\u0440: \u0432\u044B\u0434\u0430\u0451\u0442 \u0434\u0435\u043D\u044C\u0433\u0438 \u0438 \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0435\u0442 \u043E\u0442\u0447\u0451\u0442 \u043E \u0440\u0430\u0441\u0445\u043E\u0434\u0430\u0445."
      }
    ],
    steps: [
      { id: "approve", type: "approval_chain", title: "\u0421\u043E\u0433\u043B\u0430\u0441\u043E\u0432\u0430\u043D\u0438\u0435", until: "approver" },
      { id: "approved", type: "status", status: "approved", title: "\u0412\u044B\u0434\u0430\u0447\u0430 \u0441\u043E\u0433\u043B\u0430\u0441\u043E\u0432\u0430\u043D\u0430" },
      {
        id: "issue",
        type: "task",
        title: "\u0412\u044B\u0434\u0430\u0442\u044C \u043D\u0430\u043B\u0438\u0447\u043D\u044B\u0435",
        assignee: { role: "bookkeeper" },
        doneLabel: "\u0412\u044B\u0434\u0430\u043D\u043E"
      },
      { id: "issued", type: "status", status: "issued", title: "\u041D\u0430\u043B\u0438\u0447\u043D\u044B\u0435 \u0432\u044B\u0434\u0430\u043D\u044B" },
      {
        id: "report",
        type: "task",
        title: "\u041E\u0442\u0447\u0451\u0442 \u043E \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u044B\u0445 \u043D\u0430\u043B\u0438\u0447\u043D\u044B\u0445",
        assignee: { author: true },
        hint: "\u041E\u043F\u0438\u0448\u0438\u0442\u0435, \u043D\u0430 \u0447\u0442\u043E \u043F\u043E\u0442\u0440\u0430\u0447\u0435\u043D\u044B \u0434\u0435\u043D\u044C\u0433\u0438, \u0438 \u043F\u0440\u0438\u043B\u043E\u0436\u0438\u0442\u0435 \u0447\u0435\u043A\u0438.",
        doneLabel: "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043E\u0442\u0447\u0451\u0442",
        fields: [
          { key: "reportText", label: "\u041E\u0442\u0447\u0451\u0442 \u043E \u0440\u0430\u0441\u0445\u043E\u0434\u0430\u0445", type: "textarea", required: true },
          { key: "reportFiles", label: "\u0427\u0435\u043A\u0438", type: "files" }
        ]
      },
      {
        id: "check",
        type: "task",
        title: "\u0423\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435 \u043E\u0442\u0447\u0451\u0442\u0430",
        assignee: { role: "bookkeeper" },
        doneLabel: "\u041E\u0442\u0447\u0451\u0442 \u043F\u0440\u0438\u043D\u044F\u0442",
        returnTo: { step: "report", label: "\u0417\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u044C \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E" }
      },
      { id: "closed", type: "status", status: "closed", title: "\u0417\u0430\u044F\u0432\u043A\u0430 \u0437\u0430\u043A\u0440\u044B\u0442\u0430" }
    ]
  },
  outgoing: {
    code: "outgoing",
    title: "\u0418\u0441\u0445\u043E\u0434\u044F\u0449\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B",
    entityType: "request",
    roles: [
      {
        code: "registrar",
        label: "\u041A\u0442\u043E \u0444\u0438\u043A\u0441\u0438\u0440\u0443\u0435\u0442",
        description: "\u0421\u0435\u043A\u0440\u0435\u0442\u0430\u0440\u044C \u0438\u043B\u0438 \u043E\u0444\u0438\u0441-\u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440: \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u0443\u0435\u0442 \u0438\u0441\u0445\u043E\u0434\u044F\u0449\u0438\u0439 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0432 \u0436\u0443\u0440\u043D\u0430\u043B\u0435."
      }
    ],
    steps: [
      {
        id: "register",
        type: "task",
        title: "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442",
        assignee: { role: "registrar" },
        doneLabel: "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043E",
        fields: [{ key: "regNumber", label: "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440", type: "text", required: true }]
      },
      { id: "registered", type: "status", status: "registered", title: "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D" }
    ]
  }
};
var ROUTE_CODES = Object.keys(ROUTES);
function getRoute(code) {
  return ROUTES[code];
}
var roleSettingKey = (route, role) => `${route}.${role}`;
var COMPANY_UTC_OFFSET = "+03:00";
var WORKDAY_START = "09:00";

// src/crm.ts
import { z as z2 } from "zod";

// src/listing.ts
import { z } from "zod";
var SORT_DIRS = ["asc", "desc"];
var filterDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "\u0414\u0430\u0442\u0430 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 \u0413\u0413\u0413\u0413-\u041C\u041C-\u0414\u0414").optional();
var queryFlag = z.union([z.boolean(), z.enum(["true", "false"])]).transform((v) => v === true || v === "true").optional();
function companyDayStart(isoDate5) {
  return /* @__PURE__ */ new Date(`${isoDate5}T00:00:00${COMPANY_UTC_OFFSET}`);
}
function companyDayEndExclusive(isoDate5) {
  const d = companyDayStart(isoDate5);
  return new Date(d.getTime() + 24 * 36e5);
}
var SAVED_FILTER_PAGES = ["tasks", "deals", "contacts"];
var filterValue = z.union([z.string().max(500), z.number(), z.boolean()]);
var savedFilterInputSchema = z.object({
  page: z.enum(SAVED_FILTER_PAGES),
  name: z.string().trim().min(1, "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435").max(100),
  /** Параметры адресной строки списка (без вида и страницы) */
  params: z.record(z.string().max(50), filterValue).refine((v) => Object.keys(v).length <= 30, {
    message: "\u0421\u043B\u0438\u0448\u043A\u043E\u043C \u043C\u043D\u043E\u0433\u043E \u0443\u0441\u043B\u043E\u0432\u0438\u0439"
  })
});
var SAVED_FILTER_LIMIT = 30;
var BULK_LIMIT = 2e3;
var COLUMN_TABLES = ["tasks", "deals", "contacts", "equipment"];
var columnsSettingKey = (table) => `columns:${table}`;
var USER_SETTING_KEYS = COLUMN_TABLES.map(columnsSettingKey);
var hiddenColumnsSchema = z.object({ value: z.array(z.string().min(1).max(50)).max(50) });
var setPhotoSchema = z.object({ fileId: z.uuid().nullable() });
var PHOTO_MAX_SIZE = 5 * 1024 * 1024;
var PHOTO_MIMES = ["image/jpeg", "image/png", "image/webp"];

// src/crm.ts
var trimmed = (max) => z2.string().trim().min(1, "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435").max(max);
var optionalText = (max) => z2.string().trim().max(max).transform((v) => v === "" ? null : v).nullish();
var uuid = z2.uuid("\u041D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440");
var isoDate = z2.string().regex(/^\d{4}-\d{2}-\d{2}$/, "\u0414\u0430\u0442\u0430 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 \u0413\u0413\u0413\u0413-\u041C\u041C-\u0414\u0414");
var money = z2.coerce.number({ error: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0447\u0438\u0441\u043B\u043E" }).min(0, "\u041D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043E\u0442\u0440\u0438\u0446\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0439").max(1e12, "\u0421\u043B\u0438\u0448\u043A\u043E\u043C \u0431\u043E\u043B\u044C\u0448\u043E\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435");
var flag = z2.union([z2.boolean(), z2.enum(["true", "false"])]).transform((v) => v === true || v === "true").optional();
var STAGE_SEMANTICS = ["open", "won", "lost"];
var STAGE_SEMANTIC_LABELS = {
  open: "\u0412 \u0440\u0430\u0431\u043E\u0442\u0435",
  won: "\u0423\u0441\u043F\u0435\u0448\u043D\u0430\u044F",
  lost: "\u041F\u0440\u043E\u0432\u0430\u043B"
};
var MESSENGER_CHANNELS = ["telegram", "max"];
var MESSENGER_LABELS = { telegram: "Telegram", max: "MAX" };
var DEAL_SOURCES = [
  "manual",
  "phone",
  "telegram",
  "max",
  "email",
  "site",
  "avito",
  "other"
];
var DEAL_SOURCE_LABELS = {
  manual: "\u0412\u0440\u0443\u0447\u043D\u0443\u044E",
  phone: "\u0417\u0432\u043E\u043D\u043E\u043A",
  telegram: "Telegram",
  max: "MAX",
  email: "\u041F\u043E\u0447\u0442\u0430",
  site: "\u0421\u0430\u0439\u0442",
  avito: "\u0410\u0432\u0438\u0442\u043E",
  other: "\u0414\u0440\u0443\u0433\u043E\u0435"
};
var ACTIVITY_TYPES = ["call", "meeting", "todo", "email"];
var ACTIVITY_TYPE_LABELS = {
  call: "\u0417\u0432\u043E\u043D\u043E\u043A",
  meeting: "\u0412\u0441\u0442\u0440\u0435\u0447\u0430",
  todo: "\u0414\u0435\u043B\u043E",
  email: "\u041F\u0438\u0441\u044C\u043C\u043E"
};
var STAGE_COLORS = [
  "#6B8299",
  "#3E7CB1",
  "#2F9C95",
  "#7A6FB0",
  "#B07A3E",
  "#9A8F84",
  "#2E8B57",
  "#C0473B"
];
function normalizePhone(raw) {
  const trimmedRaw = raw.trim();
  const digits = trimmedRaw.replace(/\D/g, "");
  if (digits.length === 11 && (digits.startsWith("8") || digits.startsWith("7")))
    return `+7${digits.slice(1)}`;
  if (digits.length === 10 && digits.startsWith("9")) return `+7${digits}`;
  if (digits.length >= 11 && digits.length <= 15) return `+${digits}`;
  return trimmedRaw;
}
function formatPhone(phone2) {
  const m = /^\+7(\d{3})(\d{3})(\d{2})(\d{2})$/.exec(phone2);
  return m ? `+7 ${m[1]} ${m[2]}-${m[3]}-${m[4]}` : phone2;
}
var phones = z2.array(z2.string().trim().max(50)).max(10).transform((list) => [...new Set(list.filter(Boolean).map(normalizePhone))]);
var emails = z2.array(z2.string().trim().max(200)).max(10).transform((list) => [...new Set(list.filter(Boolean).map((e) => e.toLowerCase()))]).pipe(z2.array(z2.email("\u041D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 e-mail")));
var contactInputSchema = z2.object({
  fullName: trimmed(200),
  companyId: uuid.nullish(),
  position: optionalText(200),
  phones: phones.optional(),
  emails: emails.optional(),
  city: optionalText(200),
  notes: optionalText(5e3),
  ownerId: uuid.nullish(),
  source: z2.enum(DEAL_SOURCES).optional()
});
var updateContactSchema = contactInputSchema.partial();
var CONTACT_SORTS = ["name", "company", "deals", "owner", "activity", "updated"];
var ACTIVITY_FILTERS = ["overdue", "today", "planned", "none"];
var ACTIVITY_FILTER_LABELS = {
  overdue: "\u041F\u0440\u043E\u0441\u0440\u043E\u0447\u0435\u043D\u043D\u044B\u0435 \u0434\u0435\u043B\u0430",
  today: "\u0414\u0435\u043B\u0430 \u043D\u0430 \u0441\u0435\u0433\u043E\u0434\u043D\u044F",
  planned: "\u0415\u0441\u0442\u044C \u0437\u0430\u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u0434\u0435\u043B\u0430",
  none: "\u0411\u0435\u0437 \u0434\u0435\u043B"
};
var listContactsQuerySchema = z2.object({
  q: z2.string().trim().max(200).optional(),
  mine: flag,
  companyId: uuid.optional(),
  ownerId: uuid.optional(),
  activity: z2.enum(ACTIVITY_FILTERS).optional(),
  sort: z2.enum(CONTACT_SORTS).optional(),
  dir: z2.enum(SORT_DIRS).default("asc"),
  page: z2.coerce.number().int().min(1).default(1),
  pageSize: z2.coerce.number().int().min(1).max(200).default(50)
});
var companyInputSchema = z2.object({
  name: trimmed(300),
  inn: z2.string().trim().regex(/^(\d{10}|\d{12})?$/, "\u0418\u041D\u041D \u2014 10 \u0438\u043B\u0438 12 \u0446\u0438\u0444\u0440").transform((v) => v || null).nullish(),
  kpp: z2.string().trim().regex(/^(\d{9})?$/, "\u041A\u041F\u041F \u2014 9 \u0446\u0438\u0444\u0440").transform((v) => v || null).nullish(),
  city: optionalText(200),
  address: optionalText(500),
  phones: phones.optional(),
  emails: emails.optional(),
  website: optionalText(300),
  notes: optionalText(5e3),
  ownerId: uuid.nullish()
});
var updateCompanySchema = companyInputSchema.partial();
var listCompaniesQuerySchema = z2.object({
  q: z2.string().trim().max(200).optional(),
  page: z2.coerce.number().int().min(1).default(1),
  pageSize: z2.coerce.number().int().min(1).max(200).default(50)
});
var mergeContactSchema = z2.object({ targetId: uuid });
var saveStagesSchema = z2.object({
  stages: z2.array(
    z2.object({
      id: uuid.optional(),
      name: trimmed(100),
      color: z2.string().regex(/^#[0-9a-fA-F]{6}$/, "\u0426\u0432\u0435\u0442 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 #RRGGBB"),
      semantic: z2.enum(STAGE_SEMANTICS)
    })
  ).min(3).max(30)
}).superRefine((v, ctx) => {
  if (v.stages[0]?.semantic !== "open")
    ctx.addIssue({
      code: "custom",
      message: "\u041F\u0435\u0440\u0432\u0430\u044F \u0441\u0442\u0430\u0434\u0438\u044F \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u0440\u0430\u0431\u043E\u0447\u0435\u0439 \u2014 \u043D\u0430 \u043D\u0435\u0451 \u043F\u043E\u043F\u0430\u0434\u0430\u044E\u0442 \u043D\u043E\u0432\u044B\u0435 \u0441\u0434\u0435\u043B\u043A\u0438"
    });
  for (const s of STAGE_SEMANTICS)
    if (!v.stages.some((x) => x.semantic === s))
      ctx.addIssue({ code: "custom", message: `\u041D\u0443\u0436\u043D\u0430 \u0445\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u0430 \u0441\u0442\u0430\u0434\u0438\u044F \xAB${STAGE_SEMANTIC_LABELS[s]}\xBB` });
  const names = v.stages.map((s) => s.name.toLowerCase());
  if (new Set(names).size !== names.length)
    ctx.addIssue({ code: "custom", message: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u044F \u0441\u0442\u0430\u0434\u0438\u0439 \u043F\u043E\u0432\u0442\u043E\u0440\u044F\u044E\u0442\u0441\u044F" });
});
var saveDirectionsSchema = z2.object({
  directions: z2.array(z2.object({ id: uuid.optional(), name: trimmed(100), isActive: z2.boolean().default(true) })).max(50)
});
var crmSettingsSchema = z2.object({
  /** Кому достаются новые обращения из мессенджеров (пусто — «без ответственного», видят все) */
  inboxOwnerId: uuid.nullish(),
  /** Автоответ на первое сообщение нового клиента */
  greeting: optionalText(1e3)
});
var dealInputSchema = z2.object({
  title: trimmed(300),
  contactId: uuid.nullish(),
  companyId: uuid.nullish(),
  directionId: uuid.nullish(),
  stageId: uuid.optional(),
  ownerId: uuid.nullish(),
  amount: money.nullish(),
  closeDate: isoDate.nullish(),
  description: optionalText(1e4),
  source: z2.enum(DEAL_SOURCES).optional()
});
var updateDealSchema = dealInputSchema.omit({ stageId: true }).partial();
var quickDealSchema = z2.object({
  title: trimmed(300),
  contactId: uuid.nullish(),
  clientName: optionalText(200),
  phone: optionalText(50),
  amount: money.nullish(),
  directionId: uuid.nullish()
}).refine((v) => v.contactId || v.clientName || v.phone, {
  message: "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u043A\u043B\u0438\u0435\u043D\u0442\u0430: \u0438\u043C\u044F \u0438\u043B\u0438 \u0442\u0435\u043B\u0435\u0444\u043E\u043D",
  path: ["clientName"]
});
var moveDealSchema = z2.object({
  stageId: uuid,
  afterId: uuid.optional(),
  beforeId: uuid.optional(),
  lostReason: optionalText(1e3)
});
var DEAL_STATES = ["open", "won", "lost", "all"];
var DEAL_SORTS = [
  "number",
  "title",
  "stage",
  "amount",
  "owner",
  "created",
  "closed",
  "activity"
];
var listDealsQuerySchema = z2.object({
  scope: z2.enum(["mine", "all", "free"]).default("all"),
  state: z2.enum(DEAL_STATES).default("open"),
  /** Для канбана: закрытые сделки за последние 30 дней в колонках «Успешная»/«Провал» */
  board: flag,
  ownerId: uuid.optional(),
  directionId: uuid.optional(),
  stageId: uuid.optional(),
  contactId: uuid.optional(),
  companyId: uuid.optional(),
  q: z2.string().trim().max(200).optional(),
  createdFrom: filterDate,
  createdTo: filterDate,
  closedFrom: filterDate,
  closedTo: filterDate,
  amountFrom: z2.coerce.number().min(0).optional(),
  amountTo: z2.coerce.number().min(0).optional(),
  /** Источники через запятую */
  source: z2.string().optional().transform(
    (v) => v ? v.split(",").filter((s) => DEAL_SOURCES.includes(s)) : void 0
  ),
  activity: z2.enum(ACTIVITY_FILTERS).optional(),
  sort: z2.enum(DEAL_SORTS).optional(),
  dir: z2.enum(SORT_DIRS).default("asc"),
  page: z2.coerce.number().int().min(1).default(1),
  pageSize: z2.coerce.number().int().min(1).max(500).default(50)
});
var bulkDealsSchema = z2.object({
  ids: z2.array(uuid).max(BULK_LIMIT).optional(),
  filter: z2.record(z2.string(), z2.unknown()).optional(),
  ownerId: uuid.nullish(),
  stageId: uuid.optional(),
  lostReason: optionalText(1e3),
  directionId: uuid.nullish()
}).refine((v) => Boolean(v.ids?.length) !== Boolean(v.filter), { message: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0434\u0435\u043B\u043A\u0438" }).refine(
  (v) => [v.ownerId !== void 0, v.stageId !== void 0, v.directionId !== void 0].filter(Boolean).length === 1,
  { message: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043E\u0434\u043D\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435" }
);
var dealItemInputSchema = z2.object({
  productId: uuid.nullish(),
  name: trimmed(500),
  sku: optionalText(100),
  qty: z2.coerce.number().positive("\u041A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0443\u043B\u044F").max(1e9),
  unit: optionalText(20),
  price: money
});
var saveDealItemsSchema = z2.object({ items: z2.array(dealItemInputSchema).max(200) });
var productInputSchema = z2.object({
  sku: optionalText(100),
  name: trimmed(500),
  unit: z2.string().trim().max(20).default("\u0448\u0442"),
  price: money.default(0),
  isActive: z2.boolean().default(true)
});
var updateProductSchema = productInputSchema.partial();
var listProductsQuerySchema = z2.object({
  q: z2.string().trim().max(200).optional(),
  includeInactive: flag,
  page: z2.coerce.number().int().min(1).default(1),
  pageSize: z2.coerce.number().int().min(1).max(200).default(50)
});
var activityInputSchema = z2.object({
  type: z2.enum(ACTIVITY_TYPES),
  subject: trimmed(500),
  description: optionalText(5e3),
  dueAt: z2.iso.datetime({ offset: true, error: "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0434\u0430\u0442\u0443 \u0438 \u0432\u0440\u0435\u043C\u044F" }),
  dealId: uuid.nullish(),
  contactId: uuid.nullish(),
  responsibleId: uuid.optional()
}).refine((v) => v.dealId || v.contactId, { message: "\u0414\u0435\u043B\u043E \u043F\u0440\u0438\u0432\u044F\u0437\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u043A \u0441\u0434\u0435\u043B\u043A\u0435 \u0438\u043B\u0438 \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u0443" });
var updateActivitySchema = z2.object({
  subject: trimmed(500).optional(),
  description: optionalText(5e3),
  dueAt: z2.iso.datetime({ offset: true }).optional(),
  responsibleId: uuid.optional()
});
var completeActivitySchema = z2.object({
  result: optionalText(5e3),
  done: z2.boolean().default(true)
});
var listActivitiesQuerySchema = z2.object({
  state: z2.enum(["open", "done"]).default("open"),
  scope: z2.enum(["mine", "all"]).default("mine"),
  dealId: uuid.optional(),
  contactId: uuid.optional(),
  limit: z2.coerce.number().int().min(1).max(500).default(200)
});
var sendMessageSchema = z2.object({
  text: optionalText(4e3),
  fileIds: z2.array(uuid).max(5).optional()
}).refine((v) => v.text || v.fileIds?.length, { message: "\u041F\u0443\u0441\u0442\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435" });
var linkChatSchema = z2.object({ contactId: uuid });
var listChatsQuerySchema = z2.object({
  unread: flag,
  q: z2.string().trim().max(200).optional(),
  limit: z2.coerce.number().int().min(1).max(200).default(100)
});

// src/equipment.ts
import { z as z3 } from "zod";
var trimmed2 = (max) => z3.string().trim().min(1, "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435").max(max);
var optionalText2 = (max) => z3.string().trim().max(max).transform((v) => v === "" ? null : v).nullish();
var uuid2 = z3.uuid("\u041D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440");
var isoDate2 = z3.string().regex(/^\d{4}-\d{2}-\d{2}$/, "\u0414\u0430\u0442\u0430 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 \u0413\u0413\u0413\u0413-\u041C\u041C-\u0414\u0414").nullish().or(z3.literal("").transform(() => null));
var flag2 = z3.union([z3.boolean(), z3.enum(["true", "false"])]).transform((v) => v === true || v === "true").optional();
var EQUIPMENT_LIFECYCLES = ["production", "in_service", "decommissioned"];
var EQUIPMENT_LIFECYCLE_LABELS = {
  production: "\u0412 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u0435",
  in_service: "\u0423 \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
  decommissioned: "\u0421\u043F\u0438\u0441\u0430\u043D\u043E"
};
var PRODUCTION_STAGE_KINDS = ["work", "paused", "ready"];
var PRODUCTION_STAGE_KIND_LABELS = {
  work: "\u0420\u0430\u0431\u043E\u0447\u0438\u0439 \u044D\u0442\u0430\u043F",
  paused: "\u041F\u0430\u0443\u0437\u0430",
  ready: "\u0413\u043E\u0442\u043E\u0432 \u043A \u043E\u0442\u0433\u0440\u0443\u0437\u043A\u0435"
};
var TICKET_PRIORITIES = ["low", "normal", "high", "critical"];
var TICKET_PRIORITY_LABELS = {
  low: "\u041D\u0438\u0437\u043A\u0438\u0439",
  normal: "\u041E\u0431\u044B\u0447\u043D\u044B\u0439",
  high: "\u0412\u044B\u0441\u043E\u043A\u0438\u0439",
  critical: "\u041A\u0440\u0438\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0439"
};
var TICKET_STATUSES = ["new", "in_progress", "waiting", "done", "cancelled"];
var TICKET_STATUS_LABELS = {
  new: "\u041D\u043E\u0432\u0430\u044F",
  in_progress: "\u0412 \u0440\u0430\u0431\u043E\u0442\u0435",
  waiting: "\u0416\u0434\u0451\u043C \u043A\u043B\u0438\u0435\u043D\u0442\u0430",
  done: "\u0412\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0430",
  cancelled: "\u041E\u0442\u043C\u0435\u043D\u0435\u043D\u0430"
};
var OPEN_TICKET_STATUSES = ["new", "in_progress", "waiting"];
var TICKET_SOURCES = ["manual", "phone", "telegram", "max", "email", "visit"];
var TICKET_SOURCE_LABELS = {
  manual: "\u0412\u0440\u0443\u0447\u043D\u0443\u044E",
  phone: "\u0417\u0432\u043E\u043D\u043E\u043A",
  telegram: "Telegram",
  max: "MAX",
  email: "\u041F\u043E\u0447\u0442\u0430",
  visit: "\u0412\u0438\u0437\u0438\u0442"
};
var DEFAULT_SLA = {
  critical: { reactionHours: 1, resolveHours: 8 },
  high: { reactionHours: 4, resolveHours: 24 },
  normal: { reactionHours: 8, resolveHours: 72 },
  low: { reactionHours: 24, resolveHours: 168 }
};
var namedList = z3.array(z3.object({ id: uuid2.optional(), name: trimmed2(100), isActive: z3.boolean().default(true) })).max(100).superRefine((list, ctx) => {
  const names = list.map((x) => x.name.toLowerCase());
  if (new Set(names).size !== names.length)
    ctx.addIssue({ code: "custom", message: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u0432\u0442\u043E\u0440\u044F\u044E\u0442\u0441\u044F" });
});
var saveModelsSchema = z3.object({ models: namedList });
var saveCategoriesSchema = z3.object({ categories: namedList });
var saveProductionStagesSchema = z3.object({
  stages: z3.array(
    z3.object({
      id: uuid2.optional(),
      name: trimmed2(100),
      color: z3.string().regex(/^#[0-9a-fA-F]{6}$/, "\u0426\u0432\u0435\u0442 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 #RRGGBB"),
      kind: z3.enum(PRODUCTION_STAGE_KINDS)
    })
  ).min(2).max(30)
}).superRefine((v, ctx) => {
  if (v.stages[0]?.kind !== "work")
    ctx.addIssue({
      code: "custom",
      message: "\u041F\u0435\u0440\u0432\u044B\u0439 \u044D\u0442\u0430\u043F \u0434\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u0440\u0430\u0431\u043E\u0447\u0438\u043C \u2014 \u043D\u0430 \u043D\u0435\u0433\u043E \u043F\u043E\u043F\u0430\u0434\u0430\u044E\u0442 \u043D\u043E\u0432\u044B\u0435 \u0441\u0442\u0435\u043D\u0434\u044B"
    });
  if (!v.stages.some((s) => s.kind === "ready"))
    ctx.addIssue({ code: "custom", message: "\u041D\u0443\u0436\u0435\u043D \u044D\u0442\u0430\u043F \xAB\u0413\u043E\u0442\u043E\u0432 \u043A \u043E\u0442\u0433\u0440\u0443\u0437\u043A\u0435\xBB \u2014 \u0441 \u043D\u0435\u0433\u043E \u0441\u0442\u0435\u043D\u0434 \u043E\u0442\u0433\u0440\u0443\u0436\u0430\u044E\u0442" });
  const names = v.stages.map((s) => s.name.toLowerCase());
  if (new Set(names).size !== names.length)
    ctx.addIssue({ code: "custom", message: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u044F \u044D\u0442\u0430\u043F\u043E\u0432 \u043F\u043E\u0432\u0442\u043E\u0440\u044F\u044E\u0442\u0441\u044F" });
});
var hours = z3.coerce.number({ error: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0447\u0438\u0441\u043B\u043E \u0447\u0430\u0441\u043E\u0432" }).min(0.25, "\u041D\u0435 \u043C\u0435\u043D\u044C\u0448\u0435 15 \u043C\u0438\u043D\u0443\u0442").max(2e3, "\u041D\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 2000 \u0447\u0430\u0441\u043E\u0432");
var saveSlaSchema = z3.object({
  rules: z3.array(z3.object({ priority: z3.enum(TICKET_PRIORITIES), reactionHours: hours, resolveHours: hours })).length(TICKET_PRIORITIES.length)
}).superRefine((v, ctx) => {
  for (const p of TICKET_PRIORITIES)
    if (!v.rules.some((r) => r.priority === p))
      ctx.addIssue({ code: "custom", message: `\u041D\u0435\u0442 \u0441\u0440\u043E\u043A\u043E\u0432 \u0434\u043B\u044F \u043F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442\u0430 \xAB${TICKET_PRIORITY_LABELS[p]}\xBB` });
  for (const r of v.rules)
    if (r.resolveHours < r.reactionHours)
      ctx.addIssue({
        code: "custom",
        message: `\xAB${TICKET_PRIORITY_LABELS[r.priority]}\xBB: \u0441\u0440\u043E\u043A \u0440\u0435\u0448\u0435\u043D\u0438\u044F \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043C\u0435\u043D\u044C\u0448\u0435 \u0441\u0440\u043E\u043A\u0430 \u0440\u0435\u0430\u043A\u0446\u0438\u0438`
      });
});
var equipmentInputSchema = z3.object({
  /** production — новый стенд в производство; in_service — уже работающее у клиента (внесение в базу) */
  lifecycle: z3.enum(["production", "in_service"]).default("production"),
  modelId: uuid2.nullish(),
  /** Своё название, если модели нет в справочнике (чужое оборудование клиента) */
  name: optionalText2(200),
  /** Заводской номер «001». Пусто — следующий по порядку */
  serialNo: optionalText2(50),
  boardId: optionalText2(100),
  assemblerId: uuid2.nullish(),
  stageId: uuid2.optional(),
  caseExpectedAt: isoDate2,
  boardExpectedAt: isoDate2,
  assembledAt: isoDate2,
  shippedAt: isoDate2,
  contactId: uuid2.nullish(),
  companyId: uuid2.nullish(),
  dealId: uuid2.nullish(),
  inventoryNo: optionalText2(100),
  location: optionalText2(300),
  warrantyUntil: isoDate2,
  contractFileId: uuid2.nullish(),
  notes: optionalText2(5e3)
});
var updateEquipmentSchema = equipmentInputSchema.omit({ lifecycle: true, stageId: true }).partial();
var moveEquipmentSchema = z3.object({
  stageId: uuid2,
  afterId: uuid2.nullish(),
  beforeId: uuid2.nullish()
});
var shipEquipmentSchema = z3.object({
  shippedAt: z3.string().regex(/^\d{4}-\d{2}-\d{2}$/, "\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u0434\u0430\u0442\u0443 \u043E\u0442\u0433\u0440\u0443\u0437\u043A\u0438"),
  contactId: uuid2.nullish(),
  companyId: uuid2.nullish(),
  dealId: uuid2.nullish(),
  warrantyUntil: isoDate2,
  location: optionalText2(300)
});
var decommissionEquipmentSchema = z3.object({ reason: trimmed2(1e3) });
var EQUIPMENT_SORTS = [
  "serial",
  "title",
  "stage",
  "client",
  "assembled",
  "shipped",
  "warranty",
  "tickets",
  "updated"
];
var EQUIPMENT_WAITING = ["case", "board", "any"];
var EQUIPMENT_WAITING_LABELS = {
  case: "\u0416\u0434\u0451\u043C \u043A\u043E\u0440\u043F\u0443\u0441",
  board: "\u0416\u0434\u0451\u043C \u043F\u043B\u0430\u0442\u0443",
  any: "\u0416\u0434\u0451\u043C \u043A\u043E\u0440\u043F\u0443\u0441 \u0438\u043B\u0438 \u043F\u043B\u0430\u0442\u0443"
};
var listEquipmentQuerySchema = z3.object({
  lifecycle: z3.enum([...EQUIPMENT_LIFECYCLES, "all"]).default("all"),
  board: flag2,
  modelId: uuid2.optional(),
  contactId: uuid2.optional(),
  companyId: uuid2.optional(),
  dealId: uuid2.optional(),
  q: z3.string().trim().max(200).optional(),
  waiting: z3.enum(EQUIPMENT_WAITING).optional(),
  sort: z3.enum(EQUIPMENT_SORTS).optional(),
  dir: z3.enum(SORT_DIRS).default("asc"),
  page: z3.coerce.number().int().min(1).default(1),
  pageSize: z3.coerce.number().int().min(1).max(500).default(50)
});
var ticketInputSchema = z3.object({
  subject: trimmed2(300),
  description: optionalText2(1e4),
  categoryId: uuid2.nullish(),
  priority: z3.enum(TICKET_PRIORITIES).default("normal"),
  equipmentId: uuid2.nullish(),
  contactId: uuid2.nullish(),
  companyId: uuid2.nullish(),
  dealId: uuid2.nullish(),
  /** Заявка из чата CRM — клиент берётся из чата */
  chatId: uuid2.nullish(),
  source: z3.enum(TICKET_SOURCES).optional(),
  assigneeId: uuid2.nullish()
});
var updateTicketSchema = ticketInputSchema.omit({ chatId: true }).partial();
var ticketStatusSchema = z3.object({
  status: z3.enum(TICKET_STATUSES),
  /** Что сделано — обязательно при «Выполнена»; причина — при «Отменена» */
  resolution: optionalText2(5e3)
});
var TICKET_SCOPES = ["all", "mine", "free", "created"];
var TICKET_STATES = ["open", "overdue", "done", "all"];
var listTicketsQuerySchema = z3.object({
  scope: z3.enum(TICKET_SCOPES).default("all"),
  state: z3.enum(TICKET_STATES).default("open"),
  equipmentId: uuid2.optional(),
  contactId: uuid2.optional(),
  companyId: uuid2.optional(),
  q: z3.string().trim().max(200).optional(),
  page: z3.coerce.number().int().min(1).default(1),
  pageSize: z3.coerce.number().int().min(1).max(200).default(50)
});
function slaState(t, now = /* @__PURE__ */ new Date()) {
  const ms = (v) => new Date(v).getTime();
  if (t.status === "cancelled") return "none";
  if (t.status === "done") return t.doneAt && ms(t.doneAt) <= ms(t.resolveDueAt) ? "met" : "breached";
  if (now.getTime() > ms(t.resolveDueAt)) return "resolve_overdue";
  if (!t.reactedAt && now.getTime() > ms(t.reactionDueAt)) return "reaction_overdue";
  return "ok";
}

// src/meals.ts
import { z as z4 } from "zod";
var isoDaySchema = z4.string().regex(/^\d{4}-\d{2}-\d{2}$/, "\u0414\u0430\u0442\u0430 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 \u0413\u0413\u0413\u0413-\u041C\u041C-\u0414\u0414");
var optionalText3 = (max) => z4.string().trim().max(max).transform((v) => v === "" ? null : v).nullish();
var MS_DAY = 864e5;
function addDaysIso(isoDate5, days) {
  return new Date((/* @__PURE__ */ new Date(`${isoDate5}T00:00:00Z`)).getTime() + days * MS_DAY).toISOString().slice(0, 10);
}
function isoWeekday(isoDate5) {
  const d = (/* @__PURE__ */ new Date(`${isoDate5}T00:00:00Z`)).getUTCDay();
  return d === 0 ? 7 : d;
}
function mealCutoff(date, deadlineTime) {
  return /* @__PURE__ */ new Date(`${addDaysIso(date, -1)}T${deadlineTime}:00${COMPANY_UTC_OFFSET}`);
}
var WEEKDAY_LABELS = ["\u041F\u043D", "\u0412\u0442", "\u0421\u0440", "\u0427\u0442", "\u041F\u0442", "\u0421\u0431", "\u0412\u0441"];
var MEAL_STATUSES = ["yes", "extra", "skip", "absent", "no", "off"];
var MEAL_STATUS_LABELS = {
  yes: "\u041E\u0431\u0435\u0434 \u0437\u0430\u043A\u0430\u0437\u0430\u043D",
  extra: "\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D \u043D\u0430 \u0434\u0435\u043D\u044C",
  skip: "\u041E\u0442\u043A\u0430\u0437 \u043D\u0430 \u0434\u0435\u043D\u044C",
  absent: "\u041E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442",
  no: "\u041D\u0435 \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D",
  off: "\u041D\u0435\u0440\u0430\u0431\u043E\u0447\u0438\u0439 \u0434\u0435\u043D\u044C"
};
var mealEats = (s) => s === "yes" || s === "extra";
function mealStatus(i) {
  if (!i.working) return "off";
  if (i.absent) return "absent";
  if (i.choice === false) return "skip";
  if (i.choice === true) return i.subscribed ? "yes" : "extra";
  return i.subscribed ? "yes" : "no";
}
var mealDayChoiceSchema = z4.object({
  /** true — буду обедать, false — отказ, null — как по подписке */
  eats: z4.boolean().nullable()
});
var mealSubscriptionSchema = z4.object({
  active: z4.boolean(),
  note: optionalText3(300)
});
var mealGuestSchema = z4.object({
  qty: z4.coerce.number().int().min(1, "\u0425\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u043D\u0430 \u043F\u043E\u0440\u0446\u0438\u044F").max(200, "\u041D\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 200"),
  note: optionalText3(300)
});
var mealRangeQuerySchema = z4.object({
  from: isoDaySchema.optional(),
  days: z4.coerce.number().int().min(1).max(62).default(14)
});
var mealReportQuerySchema = z4.object({
  month: z4.string().regex(/^\d{4}-\d{2}$/, "\u041C\u0435\u0441\u044F\u0446 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 \u0413\u0413\u0413\u0413-\u041C\u041C")
});
var mealSettingsSchema = z4.object({
  deadlineTime: z4.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, "\u0412\u0440\u0435\u043C\u044F \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 \u0427\u0427:\u041C\u041C"),
  workdays: z4.array(z4.number().int().min(1).max(7)).min(1, "\u0425\u043E\u0442\u044F \u0431\u044B \u043E\u0434\u0438\u043D \u0440\u0430\u0431\u043E\u0447\u0438\u0439 \u0434\u0435\u043D\u044C").transform((a) => [...new Set(a)].sort())
});
var mealCalendarSchema = z4.object({
  date: isoDaySchema,
  /** null — убрать исключение, день как по неделе */
  isWorking: z4.boolean().nullable(),
  note: optionalText3(200)
});
var MEAL_DEFAULT_SETTINGS = { deadlineTime: "20:00", workdays: [1, 2, 3, 4, 5] };

// src/modules.ts
var MODULES = [
  {
    code: "org",
    title: "\u0421\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0430",
    path: "/org",
    group: "company",
    status: "ready",
    sprint: 1,
    description: "\u041E\u0442\u0434\u0435\u043B\u044B, \u043F\u043E\u0434\u043E\u0442\u0447\u0451\u0442\u043D\u043E\u0441\u0442\u044C, \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u0438"
  },
  {
    code: "employees",
    title: "\u0421\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0438",
    path: "/employees",
    group: "company",
    status: "ready",
    sprint: 1,
    description: "\u0421\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432 \u0438 \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u0435\u0439"
  },
  {
    code: "tasks",
    title: "\u0417\u0430\u0434\u0430\u0447\u0438",
    path: "/tasks",
    group: "work",
    status: "ready",
    sprint: 2,
    description: "\u0421\u043F\u0438\u0441\u043A\u0438, \u043A\u0430\u043D\u0431\u0430\u043D, \u043F\u043E\u0434\u0437\u0430\u0434\u0430\u0447\u0438, \u0447\u0435\u043A-\u043B\u0438\u0441\u0442\u044B, \u0434\u0435\u0434\u043B\u0430\u0439\u043D\u044B"
  },
  {
    code: "approvals",
    title: "\u0421\u043E\u0433\u043B\u0430\u0441\u043E\u0432\u0430\u043D\u0438\u044F",
    path: "/approvals",
    group: "work",
    status: "ready",
    sprint: 3,
    description: "\u0417\u0430\u0434\u0430\u043D\u0438\u044F \u043F\u043E \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0430\u043C: \u0441\u043E\u0433\u043B\u0430\u0441\u043E\u0432\u0430\u0442\u044C, \u043E\u043F\u043B\u0430\u0442\u0438\u0442\u044C, \u043E\u0444\u043E\u0440\u043C\u0438\u0442\u044C"
  },
  {
    code: "requests",
    title: "\u0417\u0430\u044F\u0432\u043A\u0438",
    path: "/requests",
    group: "work",
    status: "ready",
    sprint: 3,
    description: "\u041A\u043E\u043C\u0430\u043D\u0434\u0438\u0440\u043E\u0432\u043A\u0438, \u0441\u0447\u0435\u0442\u0430 \u043D\u0430 \u043E\u043F\u043B\u0430\u0442\u0443, \u0432\u044B\u0434\u0430\u0447\u0430 \u043D\u0430\u043B\u0438\u0447\u043D\u044B\u0445, \u0438\u0441\u0445\u043E\u0434\u044F\u0449\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B"
  },
  {
    code: "crm",
    title: "CRM",
    path: "/crm",
    group: "sales",
    status: "ready",
    sprint: 4,
    description: "\u041A\u043B\u0438\u0435\u043D\u0442\u044B, \u0441\u0434\u0435\u043B\u043A\u0438 \u043F\u043E \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u043C, \u0434\u0435\u043B\u0430, \u0442\u043E\u0432\u0430\u0440\u044B, \u0447\u0430\u0442\u044B Telegram \u0438 MAX",
    anyOf: ["crm.access"]
  },
  {
    code: "vacations",
    title: "\u041E\u0442\u043F\u0443\u0441\u043A\u0430",
    path: "/vacations",
    group: "people",
    status: "ready",
    sprint: 3,
    description: "\u0417\u0430\u044F\u0432\u043B\u0435\u043D\u0438\u044F \u043D\u0430 \u043E\u0442\u043F\u0443\u0441\u043A \u043F\u043E \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u0443 \u0438 \u0433\u0440\u0430\u0444\u0438\u043A \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0438\u0439"
  },
  {
    code: "safety",
    title: "\u041E\u0445\u0440\u0430\u043D\u0430 \u0442\u0440\u0443\u0434\u0430",
    path: "/safety",
    group: "people",
    status: "ready",
    sprint: 7,
    description: "\u0418\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u0430\u0436\u0438, \u043E\u0431\u0443\u0447\u0435\u043D\u0438\u0435 \u0438 \u043C\u0435\u0434\u043E\u0441\u043C\u043E\u0442\u0440\u044B: \u0436\u0443\u0440\u043D\u0430\u043B, \u0441\u0440\u043E\u043A\u0438, \u043D\u0430\u043F\u043E\u043C\u0438\u043D\u0430\u043D\u0438\u044F"
  },
  {
    code: "meals",
    title: "\u041E\u0431\u0435\u0434\u044B",
    path: "/meals",
    group: "people",
    status: "ready",
    sprint: 8,
    description: "\u041A\u0442\u043E \u043E\u0431\u0435\u0434\u0430\u0435\u0442: \u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0430, \u043E\u0442\u043A\u0430\u0437 \u043D\u0430 \u0434\u0435\u043D\u044C \u0434\u043E \u0434\u0435\u0434\u043B\u0430\u0439\u043D\u0430, \u0433\u043E\u0441\u0442\u0438, \u0441\u0432\u043E\u0434\u043A\u0430 \u0437\u0430\u043A\u0430\u0437\u0430",
    anyOf: ["meals.order", "meals.manage"]
  },
  {
    code: "production",
    title: "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u043E \u0441\u0442\u0435\u043D\u0434\u043E\u0432",
    path: "/production",
    group: "service",
    status: "ready",
    sprint: 6,
    description: "\u041A\u0430\u043D\u0431\u0430\u043D \u044D\u0442\u0430\u043F\u043E\u0432 \u0441\u0431\u043E\u0440\u043A\u0438, ID \u043F\u043B\u0430\u0442, \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u0435 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0443\u044E\u0449\u0438\u0445, \u043E\u0442\u0433\u0440\u0443\u0437\u043A\u0430",
    anyOf: ["production.manage"]
  },
  {
    code: "equipment",
    title: "\u0411\u0430\u0437\u0430 \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u044F",
    path: "/equipment",
    group: "service",
    status: "ready",
    sprint: 6,
    description: "\u0421\u0442\u0435\u043D\u0434\u044B \u0443 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432: \u0434\u043E\u0433\u043E\u0432\u043E\u0440, \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u044F, \u0438\u0441\u0442\u043E\u0440\u0438\u044F \u0441\u0431\u043E\u0440\u043A\u0438 \u0438 \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u0439",
    anyOf: ["equipment.read", "helpdesk.access", "production.manage"]
  },
  {
    code: "helpdesk",
    title: "\u0421\u0435\u0440\u0432\u0438\u0441\u043D\u044B\u0435 \u0437\u0430\u044F\u0432\u043A\u0438",
    path: "/helpdesk",
    group: "service",
    status: "ready",
    sprint: 6,
    description: "\u041E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u0438 \u0440\u0435\u043C\u043E\u043D\u0442 \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u044F \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432, \u0441\u0440\u043E\u043A\u0438 \u0440\u0435\u0430\u043A\u0446\u0438\u0438 \u0438 \u0440\u0435\u0448\u0435\u043D\u0438\u044F",
    anyOf: ["helpdesk.access", "helpdesk.ticket.create", "equipment.read"]
  }
];
var MODULE_GROUPS = {
  company: "\u041A\u043E\u043C\u043F\u0430\u043D\u0438\u044F",
  work: "\u0420\u0430\u0431\u043E\u0442\u0430",
  sales: "\u041F\u0440\u043E\u0434\u0430\u0436\u0438",
  people: "\u0421\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0430\u043C",
  service: "\u041E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u0435"
};

// src/permissions.ts
var PERMISSIONS = {
  "org.department.read": "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u043E\u0440\u0433\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u044B",
  "org.department.manage": "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043E\u0442\u0434\u0435\u043B\u0430\u043C\u0438",
  "org.employee.read": "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432",
  "org.employee.manage": "\u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0438 \u0440\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432",
  "access.manage": "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0443\u0447\u0451\u0442\u043A\u0430\u043C\u0438, \u0440\u043E\u043B\u044F\u043C\u0438 \u0438 \u043F\u0440\u0430\u0432\u0430\u043C\u0438",
  "audit.read": "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0436\u0443\u0440\u043D\u0430\u043B\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0439",
  "files.upload": "\u0417\u0430\u0433\u0440\u0443\u0437\u043A\u0430 \u0444\u0430\u0439\u043B\u043E\u0432",
  "comments.write": "\u041A\u043E\u043C\u043C\u0435\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
  "tasks.task.create": "\u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0437\u0430\u0434\u0430\u0447",
  "tasks.task.read_all": "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0432\u0441\u0435\u0445 \u0437\u0430\u0434\u0430\u0447 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432 (\u0432 \u0441\u0432\u043E\u0435\u0439 \u043E\u0431\u043B\u0430\u0441\u0442\u0438)",
  "tasks.task.manage_all": "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0447\u0443\u0436\u0438\u043C\u0438 \u0437\u0430\u0434\u0430\u0447\u0430\u043C\u0438 (\u0432 \u0441\u0432\u043E\u0435\u0439 \u043E\u0431\u043B\u0430\u0441\u0442\u0438)",
  "tasks.project.create": "\u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u043E\u0432",
  "vacations.request.create": "\u041F\u043E\u0434\u0430\u0447\u0430 \u0437\u0430\u044F\u0432\u043B\u0435\u043D\u0438\u0439 \u043D\u0430 \u043E\u0442\u043F\u0443\u0441\u043A",
  "vacations.request.read_all": "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0437\u0430\u044F\u0432\u043B\u0435\u043D\u0438\u0439 \u043D\u0430 \u043E\u0442\u043F\u0443\u0441\u043A \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432 (\u0432 \u0441\u0432\u043E\u0435\u0439 \u043E\u0431\u043B\u0430\u0441\u0442\u0438)",
  "vacations.absence.manage": "\u0412\u0435\u0434\u0435\u043D\u0438\u0435 \u0433\u0440\u0430\u0444\u0438\u043A\u0430 \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0438\u0439 (\u0431\u043E\u043B\u044C\u043D\u0438\u0447\u043D\u044B\u0435, \u043E\u0442\u0433\u0443\u043B\u044B, \u043E\u0442\u043C\u0435\u043D\u0430 \u043E\u0442\u043F\u0443\u0441\u043A\u043E\u0432)",
  "requests.request.create": "\u041F\u043E\u0434\u0430\u0447\u0430 \u0437\u0430\u044F\u0432\u043E\u043A (\u043A\u043E\u043C\u0430\u043D\u0434\u0438\u0440\u043E\u0432\u043A\u0438, \u0441\u0447\u0435\u0442\u0430, \u043D\u0430\u043B\u0438\u0447\u043D\u044B\u0435, \u0438\u0441\u0445\u043E\u0434\u044F\u0449\u0438\u0435)",
  "requests.request.read_all": "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0437\u0430\u044F\u0432\u043E\u043A \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432 (\u0432 \u0441\u0432\u043E\u0435\u0439 \u043E\u0431\u043B\u0430\u0441\u0442\u0438)",
  "bpm.settings.manage": "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u043C\u0430\u0440\u0448\u0440\u0443\u0442\u043E\u0432 \u0441\u043E\u0433\u043B\u0430\u0441\u043E\u0432\u0430\u043D\u0438\u044F",
  "bpm.process.manage": "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0445\u043E\u0434\u043E\u043C \u0441\u043E\u0433\u043B\u0430\u0441\u043E\u0432\u0430\u043D\u0438\u0439: \u043F\u0435\u0440\u0435\u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435, \u043E\u0442\u043C\u0435\u043D\u0430",
  "crm.access": "\u0420\u0430\u0431\u043E\u0442\u0430 \u0432 CRM: \u043A\u043B\u0438\u0435\u043D\u0442\u044B, \u0441\u0432\u043E\u0438 \u0441\u0434\u0435\u043B\u043A\u0438, \u0447\u0430\u0442\u044B Telegram \u0438 MAX",
  "crm.deal.read_all": "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0441\u0434\u0435\u043B\u043E\u043A \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432 (\u0432 \u0441\u0432\u043E\u0435\u0439 \u043E\u0431\u043B\u0430\u0441\u0442\u0438)",
  "crm.deal.manage_all": "\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0447\u0443\u0436\u0438\u043C\u0438 \u0441\u0434\u0435\u043B\u043A\u0430\u043C\u0438 \u0438 \u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043C\u0438 (\u0432 \u0441\u0432\u043E\u0435\u0439 \u043E\u0431\u043B\u0430\u0441\u0442\u0438)",
  "crm.product.manage": "\u0412\u0435\u0434\u0435\u043D\u0438\u0435 \u0441\u043F\u0440\u0430\u0432\u043E\u0447\u043D\u0438\u043A\u0430 \u0442\u043E\u0432\u0430\u0440\u043E\u0432",
  "crm.settings.manage": "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 CRM: \u0441\u0442\u0430\u0434\u0438\u0438, \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F, \u0431\u043E\u0442\u044B",
  "equipment.read": "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0431\u0430\u0437\u044B \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u044F \u0438 \u0441\u0435\u0440\u0432\u0438\u0441\u043D\u044B\u0445 \u0437\u0430\u044F\u0432\u043E\u043A",
  "equipment.manage": "\u0412\u0435\u0434\u0435\u043D\u0438\u0435 \u0431\u0430\u0437\u044B \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u044F: \u043A\u043B\u0438\u0435\u043D\u0442, \u043C\u0435\u0441\u0442\u043E, \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u044F, \u0434\u043E\u0433\u043E\u0432\u043E\u0440",
  "production.manage": "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u043E \u0441\u0442\u0435\u043D\u0434\u043E\u0432: \u0437\u0430\u043F\u0443\u0441\u043A, \u044D\u0442\u0430\u043F\u044B \u0441\u0431\u043E\u0440\u043A\u0438, \u043E\u0442\u0433\u0440\u0443\u0437\u043A\u0430",
  "helpdesk.ticket.create": "\u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0441\u0435\u0440\u0432\u0438\u0441\u043D\u044B\u0445 \u0437\u0430\u044F\u0432\u043E\u043A",
  "helpdesk.access": "\u0420\u0430\u0431\u043E\u0442\u0430 \u0441 \u0441\u0435\u0440\u0432\u0438\u0441\u043D\u044B\u043C\u0438 \u0437\u0430\u044F\u0432\u043A\u0430\u043C\u0438: \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435, \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435, \u0437\u0430\u043A\u0440\u044B\u0442\u0438\u0435",
  "equipment.settings.manage": "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u044F \u0438 \u0441\u0435\u0440\u0432\u0438\u0441\u0430: \u043C\u043E\u0434\u0435\u043B\u0438, \u044D\u0442\u0430\u043F\u044B, \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0438, \u0441\u0440\u043E\u043A\u0438",
  "safety.read_all": "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u0430\u0436\u0435\u0439 \u0438 \u043C\u0435\u0434\u043E\u0441\u043C\u043E\u0442\u0440\u043E\u0432 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432 (\u0432 \u0441\u0432\u043E\u0435\u0439 \u043E\u0431\u043B\u0430\u0441\u0442\u0438)",
  "safety.manage": "\u0412\u0435\u0434\u0435\u043D\u0438\u0435 \u043E\u0445\u0440\u0430\u043D\u044B \u0442\u0440\u0443\u0434\u0430: \u0437\u0430\u043F\u0438\u0441\u0438 \u0436\u0443\u0440\u043D\u0430\u043B\u0430, \u043E\u0442\u043C\u0435\u0442\u043A\u0438 \xAB\u043D\u0435 \u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F\xBB (\u0432 \u0441\u0432\u043E\u0435\u0439 \u043E\u0431\u043B\u0430\u0441\u0442\u0438)",
  "safety.settings.manage": "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 \u043E\u0445\u0440\u0430\u043D\u044B \u0442\u0440\u0443\u0434\u0430: \u0432\u0438\u0434\u044B, \u043F\u0435\u0440\u0438\u043E\u0434\u0438\u0447\u043D\u043E\u0441\u0442\u044C, \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044F\u043C",
  "meals.order": "\u041E\u0431\u0435\u0434\u044B: \u043F\u043E\u0434\u043F\u0438\u0441\u043A\u0430 \u0438 \u043E\u0442\u043A\u0430\u0437 \u043D\u0430 \u0434\u0435\u043D\u044C \u0434\u043B\u044F \u0441\u0435\u0431\u044F",
  "migration.import": "\u041F\u0435\u0440\u0435\u043D\u043E\u0441 \u0434\u0430\u043D\u043D\u044B\u0445 \u0438\u0437 \u0411\u0438\u0442\u0440\u0438\u043A\u044124",
  "meals.manage": "\u0412\u0435\u0434\u0435\u043D\u0438\u0435 \u043E\u0431\u0435\u0434\u043E\u0432: \u0441\u043F\u0438\u0441\u043E\u043A \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432, \u0433\u043E\u0441\u0442\u0438, \u0441\u0432\u043E\u0434\u043A\u0430 \u0437\u0430\u043A\u0430\u0437\u0430, \u043E\u0442\u0447\u0451\u0442, \u0440\u0430\u0431\u043E\u0447\u0438\u0435 \u0434\u043D\u0438"
};
var ALL_PERMISSIONS = Object.keys(PERMISSIONS);
function isPermissionCode(value) {
  return value in PERMISSIONS;
}
function scopeCovers(scope, departmentPath) {
  if (!scope) return false;
  if (scope.global) return true;
  if (!departmentPath) return false;
  return scope.paths.some((p) => departmentPath === p || departmentPath.startsWith(`${p}.`));
}
function hasCrmAccess(perms) {
  return Boolean(perms["crm.access"]);
}
function hasEquipmentAccess(perms) {
  return Boolean(perms["equipment.read"] || perms["helpdesk.access"] || perms["production.manage"]);
}
function hasSafetyStaffAccess(perms) {
  return Boolean(perms["safety.read_all"] || perms["safety.manage"]);
}

// src/recurring.ts
import { z as z5 } from "zod";
var RECURRENCE_KINDS = ["daily", "weekly", "monthly"];
var RECURRENCE_KIND_LABELS = {
  daily: "\u041A\u0430\u0436\u0434\u044B\u0439 \u0434\u0435\u043D\u044C",
  weekly: "\u041F\u043E \u0434\u043D\u044F\u043C \u043D\u0435\u0434\u0435\u043B\u0438",
  monthly: "\u0420\u0430\u0437 \u0432 \u043C\u0435\u0441\u044F\u0446"
};
var WEEKDAY_SHORT = ["\u043F\u043D", "\u0432\u0442", "\u0441\u0440", "\u0447\u0442", "\u043F\u0442", "\u0441\u0431", "\u0432\u0441"];
var LAST_MONTH_DAY = 31;
var hhmm = z5.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, "\u0412\u0440\u0435\u043C\u044F \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 \u0427\u0427:\u041C\u041C");
var uuid3 = z5.uuid("\u041D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440");
var taskTemplateInputSchema = z5.object({
  title: z5.string().trim().min(1, "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435").max(300),
  description: z5.string().trim().max(2e4).optional(),
  assigneeId: uuid3,
  coexecutorIds: z5.array(uuid3).max(50).optional(),
  observerIds: z5.array(uuid3).max(50).optional(),
  projectId: uuid3.nullish(),
  priority: z5.enum(["low", "normal", "high"]).optional(),
  requireReview: z5.boolean().optional(),
  checklist: z5.array(z5.string().trim().min(1).max(500)).max(100).optional(),
  kind: z5.enum(RECURRENCE_KINDS),
  weekdays: z5.array(z5.number().int().min(1).max(7)).max(7).optional(),
  monthDay: z5.number().int().min(1).max(31).nullish(),
  time: hhmm,
  /** Срок задачи: через столько дней после постановки (0 — в тот же день); null — без срока */
  deadlineDays: z5.number().int().min(0).max(90).nullish(),
  deadlineTime: hhmm.optional(),
  isActive: z5.boolean().optional()
}).superRefine((v, ctx) => {
  if (v.kind === "weekly" && !v.weekdays?.length)
    ctx.addIssue({ code: "custom", path: ["weekdays"], message: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0434\u043D\u0438 \u043D\u0435\u0434\u0435\u043B\u0438" });
  if (v.kind === "monthly" && !v.monthDay)
    ctx.addIssue({ code: "custom", path: ["monthDay"], message: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0447\u0438\u0441\u043B\u043E \u043C\u0435\u0441\u044F\u0446\u0430" });
});
function offsetMinutes() {
  const sign = COMPANY_UTC_OFFSET.startsWith("-") ? -1 : 1;
  const [h, m] = COMPANY_UTC_OFFSET.slice(1).split(":").map(Number);
  return sign * ((h ?? 0) * 60 + (m ?? 0));
}
function companyDate(at) {
  return new Date(at.getTime() + offsetMinutes() * 6e4).toISOString().slice(0, 10);
}
function companyMoment(isoDate5, time) {
  return /* @__PURE__ */ new Date(`${isoDate5}T${time}:00${COMPANY_UTC_OFFSET}`);
}
function addDays(isoDate5, days) {
  const d = /* @__PURE__ */ new Date(`${isoDate5}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}
function daysInMonth(isoDate5) {
  const [y, m] = isoDate5.split("-").map(Number);
  return new Date(Date.UTC(y, m, 0)).getUTCDate();
}
function matchesDay(rule, isoDate5) {
  if (rule.kind === "daily") return true;
  if (rule.kind === "weekly") {
    const wd = (/* @__PURE__ */ new Date(`${isoDate5}T00:00:00Z`)).getUTCDay() || 7;
    return rule.weekdays.includes(wd);
  }
  const day = Number(isoDate5.slice(8, 10));
  return day === Math.min(rule.monthDay ?? 1, daysInMonth(isoDate5));
}
function nextRecurrence(rule, after) {
  let day = companyDate(after);
  for (let i = 0; i < 400; i++) {
    if (matchesDay(rule, day)) {
      const at = companyMoment(day, rule.time);
      if (at.getTime() > after.getTime()) return at;
    }
    day = addDays(day, 1);
  }
  return null;
}
function recurrenceDeadline(runAt, deadlineDays, deadlineTime) {
  if (deadlineDays === null) return null;
  return companyMoment(addDays(companyDate(runAt), deadlineDays), deadlineTime);
}
function describeRecurrence(rule) {
  const time = `\u0432 ${rule.time}`;
  if (rule.kind === "daily") return `\u041A\u0430\u0436\u0434\u044B\u0439 \u0434\u0435\u043D\u044C ${time}`;
  if (rule.kind === "weekly") {
    const days = [...rule.weekdays].sort((a, b) => a - b);
    if (days.join() === "1,2,3,4,5") return `\u041F\u043E \u0431\u0443\u0434\u043D\u044F\u043C ${time}`;
    return `\u041F\u043E ${days.map((d) => WEEKDAY_SHORT[d - 1]).join(", ")} ${time}`;
  }
  if ((rule.monthDay ?? 1) >= LAST_MONTH_DAY) return `\u0412 \u043F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0439 \u0434\u0435\u043D\u044C \u043C\u0435\u0441\u044F\u0446\u0430 ${time}`;
  return `\u041A\u0430\u0436\u0434\u043E\u0435 ${rule.monthDay}-\u0435 \u0447\u0438\u0441\u043B\u043E ${time}`;
}
function describeDeadline(deadlineDays, deadlineTime) {
  if (deadlineDays === null) return "\u0431\u0435\u0437 \u0441\u0440\u043E\u043A\u0430";
  if (deadlineDays === 0) return `\u0441\u0440\u043E\u043A \u2014 \u0432 \u0442\u043E\u0442 \u0436\u0435 \u0434\u0435\u043D\u044C \u0434\u043E ${deadlineTime}`;
  if (deadlineDays === 1) return `\u0441\u0440\u043E\u043A \u2014 \u043D\u0430 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0434\u0435\u043D\u044C \u0434\u043E ${deadlineTime}`;
  return `\u0441\u0440\u043E\u043A \u2014 \u0447\u0435\u0440\u0435\u0437 ${deadlineDays} \u0434\u043D. \u0434\u043E ${deadlineTime}`;
}

// src/roles.ts
var SYSTEM_ROLES = {
  admin: {
    code: "admin",
    name: "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440",
    description: "\u041F\u043E\u043B\u043D\u044B\u0439 \u0434\u043E\u0441\u0442\u0443\u043F \u043A\u043E \u0432\u0441\u0435\u043C \u043C\u043E\u0434\u0443\u043B\u044F\u043C \u0438 \u043D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430\u043C",
    permissions: ALL_PERMISSIONS
  },
  hr: {
    code: "hr",
    name: "\u041A\u0430\u0434\u0440\u043E\u0432\u0438\u043A",
    description: "\u0412\u0435\u0434\u0451\u0442 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432 \u0438 \u043E\u0440\u0433\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0443",
    permissions: [
      "org.department.read",
      "org.department.manage",
      "org.employee.read",
      "org.employee.manage",
      "vacations.request.read_all",
      "vacations.absence.manage"
    ]
  },
  sales_manager: {
    code: "sales_manager",
    name: "\u041C\u0435\u043D\u0435\u0434\u0436\u0435\u0440 CRM",
    description: "\u0420\u0430\u0431\u043E\u0442\u0430\u0435\u0442 \u0441 \u043A\u043B\u0438\u0435\u043D\u0442\u0430\u043C\u0438 \u0438 \u0441\u0434\u0435\u043B\u043A\u0430\u043C\u0438: \u0441\u0432\u043E\u0438 \u0441\u0434\u0435\u043B\u043A\u0438, \u043E\u0431\u0449\u0430\u044F \u0431\u0430\u0437\u0430 \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432, \u0447\u0430\u0442\u044B",
    permissions: ["crm.access", "crm.product.manage", "equipment.read"]
  },
  production: {
    code: "production",
    name: "\u041F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u043E",
    description: "\u0421\u0431\u043E\u0440\u043A\u0430 \u0441\u0442\u0435\u043D\u0434\u043E\u0432: \u0437\u0430\u043F\u0443\u0441\u043A \u0432 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u043E, \u044D\u0442\u0430\u043F\u044B, \u043E\u0442\u0433\u0440\u0443\u0437\u043A\u0430; \u0431\u0430\u0437\u0430 \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u044F",
    permissions: ["production.manage", "equipment.read", "equipment.manage"]
  },
  service: {
    code: "service",
    name: "\u0421\u0435\u0440\u0432\u0438\u0441",
    description: "\u0421\u0435\u0440\u0432\u0438\u0441\u043D\u044B\u0435 \u0437\u0430\u044F\u0432\u043A\u0438 \u043F\u043E \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u044E \u043A\u043B\u0438\u0435\u043D\u0442\u043E\u0432: \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435, \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u0438\u0435, \u0437\u0430\u043A\u0440\u044B\u0442\u0438\u0435",
    permissions: ["helpdesk.access", "equipment.read", "equipment.manage"]
  },
  safety: {
    code: "safety",
    name: "\u041E\u0445\u0440\u0430\u043D\u0430 \u0442\u0440\u0443\u0434\u0430",
    description: "\u0418\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u0430\u0436\u0438, \u043E\u0431\u0443\u0447\u0435\u043D\u0438\u0435 \u0438 \u043C\u0435\u0434\u043E\u0441\u043C\u043E\u0442\u0440\u044B: \u0436\u0443\u0440\u043D\u0430\u043B, \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044F\u043C, \u043D\u0430\u043F\u043E\u043C\u0438\u043D\u0430\u043D\u0438\u044F",
    permissions: ["org.employee.read", "safety.read_all", "safety.manage", "safety.settings.manage"]
  },
  meals: {
    code: "meals",
    name: "\u041E\u0431\u0435\u0434\u044B",
    description: "\u0412\u0435\u0434\u0451\u0442 \u043E\u0431\u0435\u0434\u044B: \u043A\u0442\u043E \u043E\u0431\u0435\u0434\u0430\u0435\u0442, \u0433\u043E\u0441\u0442\u0438, \u0441\u0432\u043E\u0434\u043A\u0430 \u0437\u0430\u043A\u0430\u0437\u0430 \u0432 \u0434\u0435\u0434\u043B\u0430\u0439\u043D, \u043E\u0442\u0447\u0451\u0442 \u0437\u0430 \u043C\u0435\u0441\u044F\u0446",
    permissions: ["org.employee.read", "meals.order", "meals.manage"]
  },
  department_head: {
    code: "department_head",
    name: "\u0420\u0443\u043A\u043E\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044C \u043E\u0442\u0434\u0435\u043B\u0430",
    description: "\u041D\u0430\u0437\u043D\u0430\u0447\u0430\u0435\u0442\u0441\u044F \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u0440\u0443\u043A\u043E\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044E \u2014 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u0435\u0442 \u043D\u0430 \u0432\u0435\u0442\u043A\u0443 \u0435\u0433\u043E \u043E\u0442\u0434\u0435\u043B\u0430",
    permissions: [
      "org.employee.read",
      "audit.read",
      "tasks.task.read_all",
      "vacations.request.read_all",
      "requests.request.read_all",
      "crm.deal.read_all",
      "crm.deal.manage_all",
      "safety.read_all"
    ]
  },
  employee: {
    code: "employee",
    name: "\u0421\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A",
    description: "\u0411\u0430\u0437\u043E\u0432\u044B\u0435 \u043F\u0440\u0430\u0432\u0430 \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u0430\u043A\u0442\u0438\u0432\u043D\u043E\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F",
    permissions: [
      "org.department.read",
      "org.employee.read",
      "files.upload",
      "comments.write",
      "tasks.task.create",
      "tasks.project.create",
      "vacations.request.create",
      "requests.request.create",
      "helpdesk.ticket.create",
      "meals.order"
    ]
  }
};
var IMPLICIT_ROLES = ["employee", "department_head"];
var ROLE_PERMISSION_UPGRADES = [
  {
    key: "role-permissions:tasks",
    grants: {
      employee: ["tasks.task.create", "tasks.project.create"],
      department_head: ["tasks.task.read_all"]
    }
  },
  {
    key: "role-permissions:bpm",
    grants: {
      employee: ["vacations.request.create", "requests.request.create"],
      department_head: ["vacations.request.read_all", "requests.request.read_all"],
      hr: ["vacations.request.read_all", "vacations.absence.manage"]
    }
  },
  {
    key: "role-permissions:crm",
    grants: {
      department_head: ["crm.deal.read_all", "crm.deal.manage_all"]
    }
  },
  {
    key: "role-permissions:equipment",
    grants: {
      employee: ["helpdesk.ticket.create"],
      sales_manager: ["equipment.read"]
    }
  },
  {
    key: "role-permissions:safety",
    grants: {
      department_head: ["safety.read_all"]
    }
  },
  {
    key: "role-permissions:meals",
    grants: {
      employee: ["meals.order"]
    }
  }
];

// src/safety.ts
import { z as z6 } from "zod";
var trimmed3 = (max) => z6.string().trim().min(1, "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435").max(max);
var optionalText4 = (max) => z6.string().trim().max(max).transform((v) => v === "" ? null : v).nullish();
var uuid4 = z6.uuid("\u041D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440");
var requiredDate = z6.string().regex(/^\d{4}-\d{2}-\d{2}$/, "\u0414\u0430\u0442\u0430 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 \u0413\u0413\u0413\u0413-\u041C\u041C-\u0414\u0414");
var isoDate3 = requiredDate.nullish().or(z6.literal("").transform(() => null));
var flag3 = z6.union([z6.boolean(), z6.enum(["true", "false"])]).transform((v) => v === true || v === "true").optional();
var SAFETY_CATEGORIES = ["instruction", "training", "medical"];
var SAFETY_CATEGORY_LABELS = {
  instruction: "\u0418\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u0430\u0436\u0438",
  training: "\u041E\u0431\u0443\u0447\u0435\u043D\u0438\u0435",
  medical: "\u041C\u0435\u0434\u043E\u0441\u043C\u043E\u0442\u0440\u044B"
};
var SAFETY_RESULTS = ["passed", "limited", "failed"];
function safetyResultLabel(category, result) {
  if (category === "medical")
    return { passed: "\u0413\u043E\u0434\u0435\u043D", limited: "\u0413\u043E\u0434\u0435\u043D \u0441 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F\u043C\u0438", failed: "\u041D\u0435 \u0433\u043E\u0434\u0435\u043D" }[result];
  return { passed: "\u041F\u0440\u043E\u0439\u0434\u0435\u043D", limited: "\u041F\u0440\u043E\u0439\u0434\u0435\u043D \u0441 \u0437\u0430\u043C\u0435\u0447\u0430\u043D\u0438\u044F\u043C\u0438", failed: "\u041D\u0435 \u043F\u0440\u043E\u0439\u0434\u0435\u043D" }[result];
}
var SAFETY_STATES = ["missing", "overdue", "soon", "ok", "exempt"];
var SAFETY_STATE_LABELS = {
  missing: "\u041D\u0435 \u043F\u0440\u043E\u0445\u043E\u0434\u0438\u043B",
  overdue: "\u041F\u0440\u043E\u0441\u0440\u043E\u0447\u0435\u043D\u043E",
  soon: "\u0421\u043A\u043E\u0440\u043E \u0441\u0440\u043E\u043A",
  ok: "\u0412 \u043F\u043E\u0440\u044F\u0434\u043A\u0435",
  exempt: "\u041D\u0435 \u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F"
};
var DEFAULT_SAFETY_KINDS = [
  {
    name: "\u0412\u0432\u043E\u0434\u043D\u044B\u0439 \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u0430\u0436",
    category: "instruction",
    periodMonths: null,
    remindDays: 14,
    appliesToAll: true,
    requiresSignature: true,
    reasonRequired: false
  },
  {
    name: "\u041F\u0435\u0440\u0432\u0438\u0447\u043D\u044B\u0439 \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u0430\u0436 \u043D\u0430 \u0440\u0430\u0431\u043E\u0447\u0435\u043C \u043C\u0435\u0441\u0442\u0435",
    category: "instruction",
    periodMonths: null,
    remindDays: 14,
    appliesToAll: true,
    requiresSignature: true,
    reasonRequired: false
  },
  {
    name: "\u041F\u043E\u0432\u0442\u043E\u0440\u043D\u044B\u0439 \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u0430\u0436",
    category: "instruction",
    periodMonths: 6,
    remindDays: 14,
    appliesToAll: true,
    requiresSignature: true,
    reasonRequired: false
  },
  {
    name: "\u0412\u043D\u0435\u043F\u043B\u0430\u043D\u043E\u0432\u044B\u0439 \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u0430\u0436",
    category: "instruction",
    periodMonths: null,
    remindDays: 14,
    appliesToAll: false,
    requiresSignature: true,
    reasonRequired: true
  },
  {
    name: "\u0426\u0435\u043B\u0435\u0432\u043E\u0439 \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u0430\u0436",
    category: "instruction",
    periodMonths: null,
    remindDays: 14,
    appliesToAll: false,
    requiresSignature: true,
    reasonRequired: true
  },
  {
    name: "\u041F\u0440\u043E\u0442\u0438\u0432\u043E\u043F\u043E\u0436\u0430\u0440\u043D\u044B\u0439 \u0438\u043D\u0441\u0442\u0440\u0443\u043A\u0442\u0430\u0436",
    category: "instruction",
    periodMonths: 6,
    remindDays: 14,
    appliesToAll: false,
    requiresSignature: true,
    reasonRequired: false
  },
  {
    name: "\u041E\u0431\u0443\u0447\u0435\u043D\u0438\u0435 \u043F\u043E \u041E\u0422: \u043E\u0431\u0449\u0438\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B (\u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430 \u0410)",
    category: "training",
    periodMonths: 36,
    remindDays: 30,
    appliesToAll: false,
    requiresSignature: true,
    reasonRequired: false
  },
  {
    name: "\u041E\u0431\u0443\u0447\u0435\u043D\u0438\u0435 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u044B\u043C \u043C\u0435\u0442\u043E\u0434\u0430\u043C \u0440\u0430\u0431\u043E\u0442 (\u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430 \u0411)",
    category: "training",
    periodMonths: 36,
    remindDays: 30,
    appliesToAll: false,
    requiresSignature: true,
    reasonRequired: false
  },
  {
    name: "\u041E\u0431\u0443\u0447\u0435\u043D\u0438\u0435 \u0440\u0430\u0431\u043E\u0442\u0430\u043C \u043F\u043E\u0432\u044B\u0448\u0435\u043D\u043D\u043E\u0439 \u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u0438 (\u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430 \u0412)",
    category: "training",
    periodMonths: 36,
    remindDays: 30,
    appliesToAll: false,
    requiresSignature: true,
    reasonRequired: false
  },
  {
    name: "\u041E\u0431\u0443\u0447\u0435\u043D\u0438\u0435 \u043E\u043A\u0430\u0437\u0430\u043D\u0438\u044E \u043F\u0435\u0440\u0432\u043E\u0439 \u043F\u043E\u043C\u043E\u0449\u0438",
    category: "training",
    periodMonths: 36,
    remindDays: 30,
    appliesToAll: false,
    requiresSignature: true,
    reasonRequired: false
  },
  {
    name: "\u041E\u0431\u0443\u0447\u0435\u043D\u0438\u0435 \u043F\u0440\u0438\u043C\u0435\u043D\u0435\u043D\u0438\u044E \u0421\u0418\u0417",
    category: "training",
    periodMonths: 36,
    remindDays: 30,
    appliesToAll: false,
    requiresSignature: true,
    reasonRequired: false
  },
  {
    name: "\u041F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043C\u0435\u0434\u043E\u0441\u043C\u043E\u0442\u0440",
    category: "medical",
    periodMonths: null,
    remindDays: 30,
    appliesToAll: false,
    requiresSignature: false,
    reasonRequired: false
  },
  {
    name: "\u041F\u0435\u0440\u0438\u043E\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043C\u0435\u0434\u043E\u0441\u043C\u043E\u0442\u0440",
    category: "medical",
    periodMonths: 12,
    remindDays: 30,
    appliesToAll: false,
    requiresSignature: false,
    reasonRequired: false
  },
  {
    name: "\u041F\u0441\u0438\u0445\u0438\u0430\u0442\u0440\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043E\u0441\u0432\u0438\u0434\u0435\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u0432\u0430\u043D\u0438\u0435",
    category: "medical",
    periodMonths: 60,
    remindDays: 30,
    appliesToAll: false,
    requiresSignature: false,
    reasonRequired: false
  }
];
var saveSafetyKindsSchema = z6.object({
  kinds: z6.array(
    z6.object({
      id: uuid4.optional(),
      name: trimmed3(200),
      category: z6.enum(SAFETY_CATEGORIES),
      periodMonths: z6.coerce.number().int().min(1, "\u041E\u0442 1 \u043C\u0435\u0441\u044F\u0446\u0430").max(120, "\u041D\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 120").nullable(),
      remindDays: z6.coerce.number().int().min(0).max(365).default(14),
      appliesToAll: z6.boolean().default(false),
      positionIds: z6.array(uuid4).max(500).default([]),
      requiresSignature: z6.boolean().default(true),
      reasonRequired: z6.boolean().default(false),
      isActive: z6.boolean().default(true)
    })
  ).max(100)
}).superRefine((v, ctx) => {
  const names = v.kinds.map((k) => k.name.toLowerCase());
  if (new Set(names).size !== names.length)
    ctx.addIssue({ code: "custom", message: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u044F \u0432\u0438\u0434\u043E\u0432 \u043F\u043E\u0432\u0442\u043E\u0440\u044F\u044E\u0442\u0441\u044F", path: ["kinds"] });
});
function addMonthsIso(isoDate5, months) {
  const [y, m, d] = isoDate5.split("-").map(Number);
  const total = y * 12 + (m - 1) + months;
  const ny = Math.floor(total / 12);
  const nm = total % 12;
  const last = new Date(Date.UTC(ny, nm + 1, 0)).getUTCDate();
  return `${ny}-${String(nm + 1).padStart(2, "0")}-${String(Math.min(d, last)).padStart(2, "0")}`;
}
function daysBetween(a, b) {
  return Math.round((Date.parse(`${b}T00:00:00Z`) - Date.parse(`${a}T00:00:00Z`)) / 864e5);
}
function safetyState(last, remindDays, today) {
  if (!last) return "missing";
  if (!last.nextDueAt) return "ok";
  const left = daysBetween(today, last.nextDueAt);
  if (left < 0) return "overdue";
  if (left <= remindDays) return "soon";
  return "ok";
}
var listSafetyStatusQuerySchema = z6.object({
  /** Через запятую: missing,overdue,soon; пусто — все, кроме «в порядке» и «не требуется» */
  state: z6.string().trim().max(100).optional().transform(
    (v) => v ? v.split(",").map((s) => s.trim()).filter((s) => SAFETY_STATES.includes(s)) : void 0
  ),
  category: z6.enum(SAFETY_CATEGORIES).optional(),
  kindId: uuid4.optional(),
  departmentId: uuid4.optional(),
  q: z6.string().trim().max(200).optional()
});
var listSafetyRecordsQuerySchema = z6.object({
  category: z6.enum(SAFETY_CATEGORIES).optional(),
  kindId: uuid4.optional(),
  employeeId: uuid4.optional(),
  departmentId: uuid4.optional(),
  from: isoDate3.optional(),
  to: isoDate3.optional(),
  /** Только ждущие подтверждения сотрудника */
  unsigned: flag3,
  q: z6.string().trim().max(200).optional(),
  page: z6.coerce.number().int().min(1).default(1),
  pageSize: z6.coerce.number().int().min(1).max(2e3).default(50),
  /** Печать журнала: по дате по возрастанию */
  order: z6.enum(["asc", "desc"]).default("desc")
});
var recordFields = {
  date: requiredDate,
  conductedById: uuid4.nullish(),
  conductedByName: optionalText4(300),
  reason: optionalText4(1e3),
  result: z6.enum(SAFETY_RESULTS).default("passed"),
  documentNo: optionalText4(100),
  /** Пусто — считается сама: дата + периодичность вида */
  nextDueAt: isoDate3.optional(),
  notes: optionalText4(2e3),
  fileId: uuid4.nullish()
};
var createSafetyRecordsSchema = z6.object({
  kindId: uuid4,
  employeeIds: z6.array(uuid4).min(1, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432").max(300),
  ...recordFields
});
var updateSafetyRecordSchema = z6.object(recordFields).partial();
var signSafetyRecordSchema = z6.object({ as: z6.enum(["employee", "conductor"]) });
var safetyExemptionSchema = z6.object({
  kindId: uuid4,
  exempt: z6.boolean(),
  reason: optionalText4(500)
});

// src/schemas.ts
import { z as z7 } from "zod";
var trimmed4 = (max) => z7.string().trim().min(1, "\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435").max(max);
var optionalText5 = (max) => z7.string().trim().max(max).transform((v) => v === "" ? null : v).nullish();
var uuid5 = z7.uuid("\u041D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440");
var loginSchema = z7.object({
  login: trimmed4(100),
  password: z7.string().min(1, "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C").max(200)
});
var createDepartmentSchema = z7.object({
  name: trimmed4(200),
  parentId: uuid5.nullish(),
  headEmployeeId: uuid5.nullish(),
  sort: z7.number().int().min(0).max(1e5).optional()
});
var updateDepartmentSchema = createDepartmentSchema.partial();
var phone = z7.string().trim().max(40).regex(/^[+\d\s()-]*$/, "\u0422\u043E\u043B\u044C\u043A\u043E \u0446\u0438\u0444\u0440\u044B, \u043F\u0440\u043E\u0431\u0435\u043B\u044B, \u0441\u043A\u043E\u0431\u043A\u0438, + \u0438 -").transform((v) => v === "" ? null : v).nullish();
var createEmployeeSchema = z7.object({
  lastName: trimmed4(100),
  firstName: trimmed4(100),
  middleName: optionalText5(100),
  positionId: uuid5.nullish(),
  departmentId: uuid5,
  managerId: uuid5.nullish(),
  email: z7.email("\u041D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u044B\u0439 email").max(200).nullish().or(z7.literal("").transform(() => null)),
  phone,
  hireDate: z7.iso.date("\u0414\u0430\u0442\u0430 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 \u0413\u0413\u0413\u0413-\u041C\u041C-\u0414\u0414").nullish()
});
var updateEmployeeSchema = createEmployeeSchema.partial().extend({
  isActive: z7.boolean().optional()
});
var listEmployeesQuerySchema = z7.object({
  q: z7.string().trim().max(100).optional(),
  departmentId: uuid5.optional(),
  includeSubdepartments: z7.enum(["true", "false"]).transform((v) => v === "true").optional(),
  includeInactive: z7.enum(["true", "false"]).transform((v) => v === "true").optional(),
  page: z7.coerce.number().int().min(1).default(1),
  pageSize: z7.coerce.number().int().min(1).max(200).default(50)
});
var createPositionSchema = z7.object({ name: trimmed4(200) });
var createUserSchema = z7.object({
  employeeId: uuid5,
  login: z7.string().trim().min(3, "\u041C\u0438\u043D\u0438\u043C\u0443\u043C 3 \u0441\u0438\u043C\u0432\u043E\u043B\u0430").max(100).regex(/^[a-zA-Z0-9._-]+$/, "\u041B\u0430\u0442\u0438\u043D\u0438\u0446\u0430, \u0446\u0438\u0444\u0440\u044B, \u0442\u043E\u0447\u043A\u0430, \u0434\u0435\u0444\u0438\u0441, \u043F\u043E\u0434\u0447\u0451\u0440\u043A\u0438\u0432\u0430\u043D\u0438\u0435"),
  password: z7.string().min(8, "\u041C\u0438\u043D\u0438\u043C\u0443\u043C 8 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432").max(200)
});
var updateUserSchema = z7.object({
  isActive: z7.boolean().optional(),
  password: z7.string().min(8, "\u041C\u0438\u043D\u0438\u043C\u0443\u043C 8 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432").max(200).optional()
});
var changeOwnPasswordSchema = z7.object({
  currentPassword: z7.string().min(1),
  newPassword: z7.string().min(8, "\u041C\u0438\u043D\u0438\u043C\u0443\u043C 8 \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432").max(200)
});
var assignRoleSchema = z7.object({
  roleCode: trimmed4(50),
  scopeDepartmentId: uuid5.nullish()
});
var ENTITY_TYPES = [
  "employee",
  "department",
  "task",
  "vacation",
  "request",
  "deal",
  "contact",
  "company",
  "equipment",
  "ticket"
];
var entityRefSchema = z7.object({
  entityType: z7.enum(ENTITY_TYPES),
  entityId: uuid5
});
var createCommentSchema = entityRefSchema.extend({
  body: z7.string().trim().min(1, "\u041F\u0443\u0441\u0442\u043E\u0439 \u043A\u043E\u043C\u043C\u0435\u043D\u0442\u0430\u0440\u0438\u0439").max(1e4),
  parentId: uuid5.nullish(),
  fileIds: z7.array(uuid5).max(20).optional()
});
var REALTIME_EVENTS = {
  notification: "notification",
  taskChanged: "task.changed",
  /** Маршрут согласования продвинулся: перечитать заявку, отпуск, список заданий */
  processChanged: "process.changed",
  /** CRM: изменилась сделка, клиент, дело или пришло сообщение в чат */
  crmChanged: "crm.changed",
  /** Производство, база оборудования или сервисная заявка изменились */
  equipmentChanged: "equipment.changed",
  /** Охрана труда: запись журнала, настройки или отметка «не требуется» */
  safetyChanged: "safety.changed",
  /** Обеды: отметка на день, гости, подписка, фиксация заказа, настройки */
  mealsChanged: "meals.changed"
};
var TASK_STATUSES = ["new", "in_progress", "review", "done", "deferred"];
var TASK_STATUS_LABELS = {
  new: "\u041D\u043E\u0432\u0430\u044F",
  in_progress: "\u0412 \u0440\u0430\u0431\u043E\u0442\u0435",
  review: "\u041D\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0435",
  done: "\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430",
  deferred: "\u041E\u0442\u043B\u043E\u0436\u0435\u043D\u0430"
};
var TASK_PRIORITIES = ["low", "normal", "high"];
var TASK_PRIORITY_LABELS = {
  low: "\u041D\u0438\u0437\u043A\u0438\u0439",
  normal: "\u041E\u0431\u044B\u0447\u043D\u044B\u0439",
  high: "\u0412\u044B\u0441\u043E\u043A\u0438\u0439"
};
var CLOSED_TASK_STATUSES = ["done", "deferred"];
var userIds = z7.array(uuid5).max(50);
var createTaskSchema = z7.object({
  title: trimmed4(300),
  description: z7.string().trim().max(2e4).optional(),
  assigneeId: uuid5.optional(),
  coexecutorIds: userIds.optional(),
  observerIds: userIds.optional(),
  projectId: uuid5.nullish(),
  parentId: uuid5.nullish(),
  deadline: z7.iso.datetime({ offset: true, message: "\u041D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u0430\u044F \u0434\u0430\u0442\u0430" }).nullish(),
  priority: z7.enum(TASK_PRIORITIES).optional(),
  requireReview: z7.boolean().optional(),
  checklist: z7.array(z7.string().trim().min(1).max(500)).max(100).optional()
});
var updateTaskSchema = createTaskSchema.omit({ checklist: true, parentId: true }).partial();
var TASK_VIEWS = ["doing", "assigned", "watching", "all"];
var TASK_VIEW_LABELS = {
  doing: "\u0414\u0435\u043B\u0430\u044E",
  assigned: "\u041F\u043E\u0440\u0443\u0447\u0438\u043B",
  watching: "\u041D\u0430\u0431\u043B\u044E\u0434\u0430\u044E",
  all: "\u0412\u0441\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0435"
};
var TASK_SORTS = [
  "number",
  "title",
  "status",
  "deadline",
  "assignee",
  "creator",
  "created",
  "activity"
];
var listTasksQuerySchema = z7.object({
  view: z7.enum(TASK_VIEWS).default("doing"),
  projectId: uuid5.optional(),
  status: z7.string().optional().transform(
    (v) => v ? v.split(",").filter((s) => TASK_STATUSES.includes(s)) : void 0
  ),
  q: z7.string().trim().max(200).optional(),
  overdue: z7.enum(["true", "false"]).transform((v) => v === "true").optional(),
  includeClosed: z7.enum(["true", "false"]).transform((v) => v === "true").optional(),
  /** deadline — по сроку (список), board — порядок карточек канбана, recent — недавно изменённые */
  order: z7.enum(["deadline", "board", "recent"]).default("deadline"),
  creatorId: uuid5.optional(),
  assigneeId: uuid5.optional(),
  /** Срок истекает в ближайшие сутки (ещё не просрочена) — «Почти просрочены» */
  dueSoon: queryFlag,
  /** Есть новые комментарии для меня */
  unread: queryFlag,
  /** Без срока */
  noDeadline: queryFlag,
  deadlineFrom: filterDate,
  deadlineTo: filterDate,
  createdFrom: filterDate,
  createdTo: filterDate,
  closedFrom: filterDate,
  closedTo: filterDate,
  /** Сортировка кликом по колонке — важнее order */
  sort: z7.enum(TASK_SORTS).optional(),
  dir: z7.enum(SORT_DIRS).default("asc"),
  page: z7.coerce.number().int().min(1).default(1),
  pageSize: z7.coerce.number().int().min(1).max(500).default(50)
});
var bulkTasksSchema = z7.object({
  ids: z7.array(uuid5).min(1, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0437\u0430\u0434\u0430\u0447\u0438").max(BULK_LIMIT),
  assigneeId: uuid5.optional(),
  status: z7.enum(TASK_STATUSES).optional(),
  deadline: z7.iso.datetime({ offset: true, message: "\u041D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u0430\u044F \u0434\u0430\u0442\u0430" }).nullish()
}).refine(
  (v) => [v.assigneeId !== void 0, v.status !== void 0, v.deadline !== void 0].filter(Boolean).length === 1,
  { message: "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043E\u0434\u043D\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435" }
);
var changeTaskStatusSchema = z7.object({ status: z7.enum(TASK_STATUSES) });
var moveTaskSchema = z7.object({
  status: z7.enum(TASK_STATUSES).optional(),
  /** Соседи в колонке после перемещения — сервер ставит задачу между ними */
  afterId: uuid5.nullish(),
  beforeId: uuid5.nullish()
});
var checklistItemSchema = z7.object({ text: trimmed4(500) });
var updateChecklistItemSchema = z7.object({
  text: trimmed4(500).optional(),
  isDone: z7.boolean().optional()
});
var createProjectSchema = z7.object({
  name: trimmed4(200),
  description: z7.string().trim().max(5e3).optional(),
  memberIds: userIds.optional()
});
var updateProjectSchema = createProjectSchema.partial().extend({ isArchived: z7.boolean().optional() });
var isoDate4 = z7.iso.date("\u041D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u0430\u044F \u0434\u0430\u0442\u0430");
var PROCESS_STATUSES = ["running", "completed", "rejected", "cancelled"];
var PROCESS_STATUS_LABELS = {
  running: "\u0418\u0434\u0451\u0442",
  completed: "\u0417\u0430\u0432\u0435\u0440\u0448\u0451\u043D",
  rejected: "\u041E\u0442\u043A\u043B\u043E\u043D\u0451\u043D",
  cancelled: "\u041E\u0442\u043C\u0435\u043D\u0451\u043D"
};
var PROCESS_DECISIONS = ["approve", "reject", "done", "return"];
var decideProcessTaskSchema = z7.object({
  decision: z7.enum(PROCESS_DECISIONS),
  comment: z7.string().trim().max(5e3).optional(),
  /** Значения полей задания: текст и даты — строкой, файлы — массивом id */
  data: z7.record(z7.string(), z7.union([z7.string().max(1e4), z7.array(uuid5).max(30)])).optional()
});
var reassignProcessTaskSchema = z7.object({ userId: uuid5 });
var updateRouteSettingsSchema = z7.object({
  /** Ключ `маршрут.роль` → пользователь (null — снять) */
  settings: z7.record(z7.string().max(100), uuid5.nullable())
});
var VACATION_TYPES = ["annual", "unpaid"];
var VACATION_TYPE_LABELS = {
  annual: "\u0415\u0436\u0435\u0433\u043E\u0434\u043D\u044B\u0439 \u043E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0435\u043C\u044B\u0439",
  unpaid: "\u0411\u0435\u0437 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F \u0437\u0430\u0440\u043F\u043B\u0430\u0442\u044B"
};
var VACATION_STATUSES = ["pending", "approved", "registered", "rejected", "cancelled"];
var VACATION_STATUS_LABELS = {
  pending: "\u041D\u0430 \u0441\u043E\u0433\u043B\u0430\u0441\u043E\u0432\u0430\u043D\u0438\u0438",
  approved: "\u0421\u043E\u0433\u043B\u0430\u0441\u043E\u0432\u0430\u043D",
  registered: "\u041E\u0444\u043E\u0440\u043C\u043B\u0435\u043D",
  rejected: "\u041E\u0442\u043A\u043B\u043E\u043D\u0451\u043D",
  cancelled: "\u041E\u0442\u043C\u0435\u043D\u0451\u043D"
};
var rangeOrdered = (v) => v.endDate >= v.startDate;
var rangeWithinYear = (v) => (Date.parse(v.endDate) - Date.parse(v.startDate)) / 864e5 < 366;
var dateRange = (shape) => z7.object({ startDate: isoDate4, endDate: isoDate4, ...shape }).refine(rangeOrdered, { message: "\u041E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u0435 \u0440\u0430\u043D\u044C\u0448\u0435 \u043D\u0430\u0447\u0430\u043B\u0430", path: ["endDate"] }).refine(rangeWithinYear, { message: "\u041D\u0435 \u0431\u043E\u043B\u044C\u0448\u0435 \u0433\u043E\u0434\u0430", path: ["endDate"] });
var createVacationSchema = dateRange({
  type: z7.enum(VACATION_TYPES).default("annual"),
  comment: optionalText5(2e3)
});
var listVacationsQuerySchema = z7.object({
  scope: z7.enum(["mine", "all"]).default("mine"),
  status: z7.enum(VACATION_STATUSES).optional(),
  type: z7.enum(VACATION_TYPES).optional(),
  /** Сотрудник (по учётке) */
  userId: uuid5.optional(),
  /** Период: отпуска, которые пересекаются с «с — по» */
  from: filterDate,
  to: filterDate,
  page: z7.coerce.number().int().min(1).default(1),
  pageSize: z7.coerce.number().int().min(1).max(200).default(50)
});
var ABSENCE_TYPES = ["vacation", "business_trip", "sick", "dayoff", "other"];
var ABSENCE_TYPE_LABELS = {
  vacation: "\u041E\u0442\u043F\u0443\u0441\u043A",
  business_trip: "\u041A\u043E\u043C\u0430\u043D\u0434\u0438\u0440\u043E\u0432\u043A\u0430",
  sick: "\u0411\u043E\u043B\u044C\u043D\u0438\u0447\u043D\u044B\u0439",
  dayoff: "\u041E\u0442\u0433\u0443\u043B",
  other: "\u0414\u0440\u0443\u0433\u043E\u0435"
};
var createAbsenceSchema = dateRange({
  employeeId: uuid5,
  type: z7.enum(ABSENCE_TYPES),
  comment: optionalText5(500)
});
var absenceChartQuerySchema = z7.object({ from: isoDate4, to: isoDate4, departmentId: uuid5.optional() }).refine((v) => v.to >= v.from && (Date.parse(v.to) - Date.parse(v.from)) / 864e5 <= 92, {
  message: "\u041F\u0435\u0440\u0438\u043E\u0434 \u2014 \u0434\u043E \u0442\u0440\u0451\u0445 \u043C\u0435\u0441\u044F\u0446\u0435\u0432",
  path: ["to"]
});
var REQUEST_TYPES = ["business_trip", "invoice", "cash", "outgoing"];
var REQUEST_TYPE_LABELS = {
  business_trip: "\u041A\u043E\u043C\u0430\u043D\u0434\u0438\u0440\u043E\u0432\u043A\u0430",
  invoice: "\u0421\u0447\u0451\u0442 \u043D\u0430 \u043E\u043F\u043B\u0430\u0442\u0443",
  cash: "\u0412\u044B\u0434\u0430\u0447\u0430 \u043D\u0430\u043B\u0438\u0447\u043D\u044B\u0445",
  outgoing: "\u0418\u0441\u0445\u043E\u0434\u044F\u0449\u0438\u0439 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442"
};
var REQUEST_STATUSES = [
  "pending",
  "approved",
  "paid",
  "issued",
  "registered",
  "closed",
  "rejected",
  "cancelled"
];
var REQUEST_STATUS_LABELS = {
  pending: "\u041D\u0430 \u0441\u043E\u0433\u043B\u0430\u0441\u043E\u0432\u0430\u043D\u0438\u0438",
  approved: "\u0421\u043E\u0433\u043B\u0430\u0441\u043E\u0432\u0430\u043D\u0430",
  paid: "\u041E\u043F\u043B\u0430\u0447\u0435\u043D",
  issued: "\u0412\u044B\u0434\u0430\u043D\u043E",
  registered: "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D",
  closed: "\u0417\u0430\u043A\u0440\u044B\u0442\u0430",
  rejected: "\u041E\u0442\u043A\u043B\u043E\u043D\u0435\u043D\u0430",
  cancelled: "\u041E\u0442\u043C\u0435\u043D\u0435\u043D\u0430"
};
var CLOSED_REQUEST_STATUSES = ["closed", "registered", "rejected", "cancelled"];
function requestStatusLabel(type, status) {
  if (type === "outgoing" && status === "pending") return "\u041D\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438";
  return REQUEST_STATUS_LABELS[status];
}
var CURRENCIES = ["RUB", "USD", "EUR", "CNY"];
var CURRENCY_SIGNS = { RUB: "\u20BD", USD: "$", EUR: "\u20AC", CNY: "\xA5" };
var money2 = z7.coerce.number({ message: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0441\u0443\u043C\u043C\u0443" }).positive("\u0421\u0443\u043C\u043C\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u0431\u043E\u043B\u044C\u0448\u0435 \u043D\u0443\u043B\u044F").max(1e9, "\u0421\u043B\u0438\u0448\u043A\u043E\u043C \u0431\u043E\u043B\u044C\u0448\u0430\u044F \u0441\u0443\u043C\u043C\u0430").transform((v) => Math.round(v * 100) / 100);
var fileIds = z7.array(uuid5).max(20);
var businessTripDataSchema = dateRange({
  destination: trimmed4(300),
  purpose: trimmed4(5e3)
});
var invoiceDataSchema = z7.object({
  purpose: trimmed4(1e3),
  supplier: optionalText5(300),
  invoiceNumber: optionalText5(100),
  invoiceDate: isoDate4.nullish(),
  amount: money2,
  currency: z7.enum(CURRENCIES).default("RUB")
});
var cashDataSchema = z7.object({
  purpose: trimmed4(5e3),
  amount: money2,
  neededBy: isoDate4.nullish()
});
var outgoingDataSchema = z7.object({
  recipient: trimmed4(300),
  documentNumber: optionalText5(100),
  documentDate: isoDate4,
  about: trimmed4(5e3)
});
var createRequestSchema = z7.discriminatedUnion("type", [
  z7.object({ type: z7.literal("business_trip"), data: businessTripDataSchema, fileIds: fileIds.optional() }),
  z7.object({
    type: z7.literal("invoice"),
    data: invoiceDataSchema,
    fileIds: fileIds.min(1, "\u041F\u0440\u0438\u043B\u043E\u0436\u0438\u0442\u0435 \u043A\u043E\u043F\u0438\u044E \u0441\u0447\u0451\u0442\u0430")
  }),
  z7.object({ type: z7.literal("cash"), data: cashDataSchema, fileIds: fileIds.optional() }),
  z7.object({ type: z7.literal("outgoing"), data: outgoingDataSchema, fileIds: fileIds.optional() })
]);
var listRequestsQuerySchema = z7.object({
  scope: z7.enum(["mine", "all"]).default("mine"),
  type: z7.enum(REQUEST_TYPES).optional(),
  /** open — в работе, closed — завершённые */
  state: z7.enum(["open", "closed"]).optional(),
  q: z7.string().trim().max(200).optional(),
  /** Автор заявки (учётка) */
  userId: uuid5.optional(),
  /** Период подачи заявки */
  createdFrom: filterDate,
  createdTo: filterDate,
  page: z7.coerce.number().int().min(1).default(1),
  pageSize: z7.coerce.number().int().min(1).max(200).default(50)
});
export {
  ABSENCE_TYPES,
  ABSENCE_TYPE_LABELS,
  ACTIVITY_FILTERS,
  ACTIVITY_FILTER_LABELS,
  ACTIVITY_TYPES,
  ACTIVITY_TYPE_LABELS,
  ALL_PERMISSIONS,
  BULK_LIMIT,
  CLOSED_REQUEST_STATUSES,
  CLOSED_TASK_STATUSES,
  COLUMN_TABLES,
  COMPANY_UTC_OFFSET,
  CONTACT_SORTS,
  CURRENCIES,
  CURRENCY_SIGNS,
  DEAL_SORTS,
  DEAL_SOURCES,
  DEAL_SOURCE_LABELS,
  DEAL_STATES,
  DEFAULT_SAFETY_KINDS,
  DEFAULT_SLA,
  ENTITY_TYPES,
  EQUIPMENT_LIFECYCLES,
  EQUIPMENT_LIFECYCLE_LABELS,
  EQUIPMENT_SORTS,
  EQUIPMENT_WAITING,
  EQUIPMENT_WAITING_LABELS,
  IMPLICIT_ROLES,
  LAST_MONTH_DAY,
  MEAL_DEFAULT_SETTINGS,
  MEAL_STATUSES,
  MEAL_STATUS_LABELS,
  MESSENGER_CHANNELS,
  MESSENGER_LABELS,
  MODULES,
  MODULE_GROUPS,
  OPEN_TICKET_STATUSES,
  PERMISSIONS,
  PHOTO_MAX_SIZE,
  PHOTO_MIMES,
  PROCESS_DECISIONS,
  PROCESS_STATUSES,
  PROCESS_STATUS_LABELS,
  PRODUCTION_STAGE_KINDS,
  PRODUCTION_STAGE_KIND_LABELS,
  REALTIME_EVENTS,
  RECURRENCE_KINDS,
  RECURRENCE_KIND_LABELS,
  REQUEST_STATUSES,
  REQUEST_STATUS_LABELS,
  REQUEST_TYPES,
  REQUEST_TYPE_LABELS,
  ROLE_PERMISSION_UPGRADES,
  ROUTES,
  ROUTE_CODES,
  SAFETY_CATEGORIES,
  SAFETY_CATEGORY_LABELS,
  SAFETY_RESULTS,
  SAFETY_STATES,
  SAFETY_STATE_LABELS,
  SAVED_FILTER_LIMIT,
  SAVED_FILTER_PAGES,
  SORT_DIRS,
  STAGE_COLORS,
  STAGE_SEMANTICS,
  STAGE_SEMANTIC_LABELS,
  SYSTEM_ROLES,
  TASK_PRIORITIES,
  TASK_PRIORITY_LABELS,
  TASK_SORTS,
  TASK_STATUSES,
  TASK_STATUS_LABELS,
  TASK_VIEWS,
  TASK_VIEW_LABELS,
  TICKET_PRIORITIES,
  TICKET_PRIORITY_LABELS,
  TICKET_SCOPES,
  TICKET_SOURCES,
  TICKET_SOURCE_LABELS,
  TICKET_STATES,
  TICKET_STATUSES,
  TICKET_STATUS_LABELS,
  USER_SETTING_KEYS,
  VACATION_STATUSES,
  VACATION_STATUS_LABELS,
  VACATION_TYPES,
  VACATION_TYPE_LABELS,
  WEEKDAY_LABELS,
  WEEKDAY_SHORT,
  WORKDAY_START,
  absenceChartQuerySchema,
  activityInputSchema,
  addDaysIso,
  addMonthsIso,
  assignRoleSchema,
  bulkDealsSchema,
  bulkTasksSchema,
  businessTripDataSchema,
  cashDataSchema,
  changeOwnPasswordSchema,
  changeTaskStatusSchema,
  checklistItemSchema,
  columnsSettingKey,
  companyDate,
  companyDayEndExclusive,
  companyDayStart,
  companyInputSchema,
  companyMoment,
  completeActivitySchema,
  contactInputSchema,
  createAbsenceSchema,
  createCommentSchema,
  createDepartmentSchema,
  createEmployeeSchema,
  createPositionSchema,
  createProjectSchema,
  createRequestSchema,
  createSafetyRecordsSchema,
  createTaskSchema,
  createUserSchema,
  createVacationSchema,
  crmSettingsSchema,
  daysBetween,
  dealInputSchema,
  dealItemInputSchema,
  decideProcessTaskSchema,
  decommissionEquipmentSchema,
  describeDeadline,
  describeRecurrence,
  entityRefSchema,
  equipmentInputSchema,
  filterDate,
  formatPhone,
  getRoute,
  hasCrmAccess,
  hasEquipmentAccess,
  hasSafetyStaffAccess,
  hiddenColumnsSchema,
  invoiceDataSchema,
  isPermissionCode,
  isoDaySchema,
  isoWeekday,
  linkChatSchema,
  listActivitiesQuerySchema,
  listChatsQuerySchema,
  listCompaniesQuerySchema,
  listContactsQuerySchema,
  listDealsQuerySchema,
  listEmployeesQuerySchema,
  listEquipmentQuerySchema,
  listProductsQuerySchema,
  listRequestsQuerySchema,
  listSafetyRecordsQuerySchema,
  listSafetyStatusQuerySchema,
  listTasksQuerySchema,
  listTicketsQuerySchema,
  listVacationsQuerySchema,
  loginSchema,
  matchesDay,
  mealCalendarSchema,
  mealCutoff,
  mealDayChoiceSchema,
  mealEats,
  mealGuestSchema,
  mealRangeQuerySchema,
  mealReportQuerySchema,
  mealSettingsSchema,
  mealStatus,
  mealSubscriptionSchema,
  mergeContactSchema,
  moveDealSchema,
  moveEquipmentSchema,
  moveTaskSchema,
  nextRecurrence,
  normalizePhone,
  outgoingDataSchema,
  productInputSchema,
  queryFlag,
  quickDealSchema,
  reassignProcessTaskSchema,
  recurrenceDeadline,
  requestStatusLabel,
  roleSettingKey,
  safetyExemptionSchema,
  safetyResultLabel,
  safetyState,
  saveCategoriesSchema,
  saveDealItemsSchema,
  saveDirectionsSchema,
  saveModelsSchema,
  saveProductionStagesSchema,
  saveSafetyKindsSchema,
  saveSlaSchema,
  saveStagesSchema,
  savedFilterInputSchema,
  scopeCovers,
  sendMessageSchema,
  setPhotoSchema,
  shipEquipmentSchema,
  signSafetyRecordSchema,
  slaState,
  taskTemplateInputSchema,
  ticketInputSchema,
  ticketStatusSchema,
  updateActivitySchema,
  updateChecklistItemSchema,
  updateCompanySchema,
  updateContactSchema,
  updateDealSchema,
  updateDepartmentSchema,
  updateEmployeeSchema,
  updateEquipmentSchema,
  updateProductSchema,
  updateProjectSchema,
  updateRouteSettingsSchema,
  updateSafetyRecordSchema,
  updateTaskSchema,
  updateTicketSchema,
  updateUserSchema
};
//# sourceMappingURL=index.js.map